/* eslint-disable */
import React, { useState, useContext, useEffect } from "react";
import { Alert, Button, Form, Spinner } from "react-bootstrap";
import CommonToggle from "../../Common/CommonToggle";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import {
  REACT_APP_ADHAAR_CARD_VERIFY_URL,
  REACT_APP_BANK_ACCOUNT_VERIFY_URL,
  USER_MANAGEMENT_URL,
} from "../../Shared/constant";
import EmptySpaceFieldValid from "../../Common/EmptySpaceFieldValid";
import CheckValid from "../../Common/CheckValid";
import { useSelector, useDispatch } from "react-redux";
import App, { WebSocketContext } from "../../../App";
import wsSend_request from "../../../Api/ws/ws_request";
import {
  parsePhoneNumber,
  getRegionCodeForCountryCode,
} from "awesome-phonenumber";
import Select from "react-select";
import CommonLoader from "../../Common/CommonLoader";
import { StartMainCommonLoader } from "../../../redux/actions/adminActions";
import CommonPermissionModel from "../../Common/CommonPermissionModel";
import { apiMapping } from "../../../APIpermission";
import VerifyModal from "../../Common/VerifyModal";
import BankDetailVerify from "../../../Api/BankDetailVerify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CommonScrollBar from "../../Common/CommonScrollBar";
import CommonAddressTextField from "../../Common/CommonAddressTextField";
import { customFilterOption } from "../../Common/customFilterOption";

const AddUser = () => {
  const Navigate = useNavigate();
  const Dispatch = useDispatch();
  const LocationRoute = useLocation()?.pathname?.split("/")[1];
  const { websocket } = useContext(WebSocketContext);
  const [UploadFileLoader, setUploadFileLoader] = useState(false);
  const [ApplicationState, setApplicationState] = useState({
    FullName: "",
    Email: "",
    Mobile: "",
    Address: "",
    address2: "",
    UserType: "",
    RelatedID: "",
    RegionType: "",
    Regional_manager: "",
    Status: true,
    user_verification: false,
  });
  const [KYCState, setKYCState] = useState({
    AccountHolderName: "",
    AccountBankName: "",
    AccountNumber: "",
    IFSCCode: "",
    AadhaarNumber: "",
  });
  const [modules, setModules] = useState({
    InventoryActive: false,
    ProductMastersActive: false,
    Dashboard: {
      SalesRevenueReport: false,
      DealerPerformance: false,
      OrderFulfillment: false,
      DailyOrdersRGLKolkata: false,
      DailyOrdersRGLDelhi: false,
      DailyOrdersRGLBangalore: false,
      AllOrderSummery: false,
    },
    DashboardMain: [
      {
        label: "Dashboard Sales Revenue Report",
        View: false,
        API: "",
      },
      {
        label: "Dashboard Ageing Outstanding",
        View: false,
        API: "",
      },
      {
        label: "Schemes Metrics",
        View: false,
        API: "",
      },
      {
        label: "Warranty Registration Report",
        View: false,
        API: "",
      },
    ],
    ProductMasters: [
      {
        label: "Product Applications",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Category",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Sub Category",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Product Group",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Product Creation",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Spares Compatibility",
        Edit: false,
        View: false,
        API: "",
      },
    ],
    StoreActive: false,
    StockDetailsReportSendMailActive: false,
    Store: [
      {
        label: "Stock Inward",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Stock Level",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Stock Details",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Stock Inward Log",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Stock Details Report",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "ERP Stock Level",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "ERP Stock Report",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Erp Stock Logs",
        Edit: false,
        View: false,
        API: "",
      },
    ],
    WarehouseActive: false,
    Warehouse: [
      {
        label: "Warehouse",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Warehouse Quick Login",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Dispatch List",
        Edit: false,
        View: false,
        API: "",
      },
    ],
    AdminToolsActive: false,
    AdminTools: [
      {
        label: "Users",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Create Franchise",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Franchise Type Report",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Rm Quick Login",
        Edit: false,
        View: false,
        API: "",
      },
    ],
    Masters: [
      {
        label: "States",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Cities",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Pincodes",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Box",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Couriers",
        Edit: false,
        View: false,
        API: "",
      },
    ],
    CRMToolsActive: false,
    CRMTools: [
      {
        label: "Region Master",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Purchase List",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Sales Person Performance",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Purchase Log List",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "All Mail Listing",
        Edit: false,
        View: false,
        API: "",
      },
    ],
    ReSellsActive: false,
    ReSells: [
      {
        label: "Resellcycle Reports",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Resale Brands",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Settings",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Age Value",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Point List",
        Edit: false,
        View: false,
        API: "",
      },
    ],
    DealerAppActive: false,
    DealerApp: [
      {
        label: "Incentive Slab",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Schemes",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Tickets",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Help Desk Category",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Help Desk Sub Category",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Help Desk FAQ",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Notifications And CMS",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Marketing Campaigns",
        Edit: false,
        View: false,
        API: "",
      },
    ],
    OrderManagementActive: false,
    OrderManagement: [
      {
        label: "All Orders Report",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "SO Creation",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "SO Approvals",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Warehouse Approvals",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Pending For Accounts",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Pending For Stores",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Pending For Dispatch",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Pending For Delivery",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Order Delivered",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Order Rejected",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Order Cancelled",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "E-Invoice Details",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "E-Invoice Cancel",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "E-Way Bill Report",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Return And Replace List",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Erp Api Failures",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "FBA Orders",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Re Assign warehouse",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Unicommerce Api Failures",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Upcoming Orders",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Draft Orders Report",
        Edit: false,
        View: false,
        API: "",
      },
    ],
    AFSOrderManagementActive: false,
    AFSOrderManagement: [
      {
        label: "After Sales Orders",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "So Creations (AFS)",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Quotation Report",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "AFS Order Sync",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Quotation Creation",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Payment Approval Pending",
        Edit: false,
        View: false,
        API: "",
      },
    ],
    PaymentManagerActive: false,
    PaymentManager: [
      {
        label: "Account Ledger Report",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Debit Credit Notes",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Debit Credit Notes Report",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Payment Approval",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Gst Data Report",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Erp Outstanding Report",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Erp General Outstanding Report",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Dealer Payment Approval",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Franchise Report",
        Edit: false,
        View: false,
        API: "",
      },
    ],
    DealerAppOnly: [
      {
        label: "Regular Order List",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Spares Order List",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Ledger",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Ticket Creation",
        Edit: false,
        View: false,
        API: "",
      },
    ],
    D2CActive: false,
    D2C: [
      {
        label: "D2C Dashboard",
        Edit: false,
        View: false,
        API: "",
      },
    ],
    Warranty: [
      {
        label: "Warranty Assure Plans",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Warranty Operations",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Warranty Review Queue",
        Edit: false,
        View: false,
        API: "",
      },
      {
        label: "Warranty View Only",
        Edit: false,
        View: false,
        API: "",
      },
    ],
  });

  const {
    ClearFormSet,
    userList,
    Regionlistall,
    userlistAll,
    currentUserDetails,
    wareHouselistall,
    device_id,
    commonMainLoader,
    selfInfo,
    AllDealerFranchiseTypeListAll,
  } = useSelector((state) => state.adminReducers);

  const CurrentData_ = currentUserDetails;
  // Function to extract API values from the object
  function extractAPIs(data) {
    const apiArray = [];
    // Iterate over each module
    if (data !== null) {
      Object.values(data).forEach((module) => {
        // Check if module is an array
        if (Array.isArray(module)) {
          // Iterate over each object in the module
          module.forEach((obj) => {
            // Check if the object has an API property
            if (obj.API) {
              // Split the API property by comma to handle multiple APIs
              const apis = obj.API.split(",").map((api) => api.trim());
              // Add each API to the apiArray
              apis.forEach((api) => {
                if (!apiArray.includes(api)) {
                  apiArray.push(api);
                }
              });
            }
          });
        }
      });
      if (ApplicationState?.UserType === "sale_franchise_person") {
        const sale_franchise_person_api = currentUserDetails?.permissions;
        return [...new Set(apiArray.concat(sale_franchise_person_api || []))];
      } else if (ApplicationState?.UserType === "franchise_manager") {
        const franchise_manager_api = [
          "add_payment_reciept",
          "list_payment_receipt",
          "get_unread_notifications",
          "get_receipt_and_order_notifications",
          "update_receipt_and_order_notifications",
          "list_marketing_campaign",
          "get_nps_notifications",
          "list_cms_notifications",
          "salesperson_send_otp",
          "salesperson_login",
          "franchise_order_list",
          "franchise_sales_list",
          "afs_order_list",
          "franchise_user_add",
          "disable_sales_executive",
          "dealer_erp_account_summary",
          "pin_code_search",
          "ticket_add",
          "ticket_list",
          "franchise_manager_dashboard",
          "product_performance",
          "product_group_list",
          "ticket_logs",
          "retry_zoho_ticket",
          "franchise_user_add",
          "salesperson_secondary_sales",
          "salesperson_purchase_add",
          "salesperson_performance_list",
          "add_app_logs",
          "get_app_version_new",
          "get_inventory_product_group",
          "get_franchise_order_details",
          "erp_outstanding_pdf",
        ];
        return [...new Set(apiArray.concat(franchise_manager_api || []))];
      } else {
        return [...new Set(apiArray)];
      }
    }
  }

  // Extract APIs
  const uniqueAPIs = extractAPIs(modules);

  const [errorAddress, seterrorAddress] = useState("");
  const [errorAddress2, seterrorAddress2] = useState("");
  const { roomId } = useParams();

  const [optionsRegion, SetOptionsRegion] = useState(() =>
    Regionlistall?.filter((elm) => elm?.is_active === true)?.map(
      (item, index) => ({
        key: item.id,
        value: item?.id,
        label: item?.region_name,
      })
    )
  );
  let defaultRegionOption = optionsRegion?.filter(
    (elm) => elm?.key === CurrentData_?.related_id
  )[0];

  const [optionsWareHouse, SetOptionsWareHouse] = useState(() =>
    wareHouselistall
      ?.filter((elm) => elm?.is_active === true)
      ?.map((item, index) => ({
        key: item.id,
        value: item?.id,
        label: `${item?.warehouse_name} (${item?.warehouse_code})`,
      }))
  );
  let defaultWareHouseOption = optionsWareHouse?.filter(
    (elm) => elm?.key === CurrentData_?.related_id
  )[0];

  const [optionsFranchise, SetOptionsFranchise] = useState(() =>
    AllDealerFranchiseTypeListAll?.list
      ?.filter((elm) => elm?.parent_id === null)
      ?.map((item, index) => ({
        ...item,
        key: item.id,
        value: item?.id,
        label: item?.customer_name,
      }))
  );
  let defaultFranchiseOption = optionsFranchise?.filter(
    (elm) => elm?.key === CurrentData_?.related_id
  )[0];

  const EmailRegex =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/; // eslint-disable-line
  const exceptThisCostSymbols = ["e", "E", "+", "-", "."];

  // error state
  const [errorFirstName, seterrorFirstName] = useState("");
  const [errorMobile, seterrorMobile] = useState("");
  const [errorEmail, seterrorEmail] = useState("");
  const [errorUserType, seterrorUserType] = useState("");
  const [errorRegionalType, seterrorerrorRegionalType] = useState("");
  const [errorRelatedID, seterrorRelatedID] = useState("");
  const [errorRegionalManager, setErrorRegionalManager] = useState("");
  const [optionsRegionalManager, SetoptionsRegionalManager] = useState([]);
  const [permissionsError, setpermissionsError] = useState("");
  const [errorAccountNumber, setErrorAccountNumber] = useState("");
  const [errorIFSCcodeNumber, setErrorIFSCcodeNumber] = useState("");
  const [errorAadhaarNumber, setErrorAadhaarNumber] = useState("");

  const [VerifyModalState, setVerifyModalState] = useState({
    open: false,
    title: "",
    modalType: "",
    data: {},
  });
  const [BankVerifiedStatus, setBankVerifiedStatus] = useState("");
  const [AadharVerifiedStatus, setAadharVerifiedStatus] = useState("");
  const [commonVerifyLoader, setcommonVerifyLoader] = useState({
    adhar_loader: false,
    bank_details_loader: false,
  });

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      fontSize: "13px", // Adjust the font size as per your requirement
    }),
  };

  //permission model
  const [showModalNew, setShowModalNew] = useState({
    open: false,
    title: "",
    modalType: "",
    Data: {},
  });

  const showPermission = (userType) => {
    setShowModalNew({
      ...showModalNew,
      open: !showModalNew?.open,
      title: "Select Permission",
      subtitle: "user permission",
      modalType: "form",
      // button: "Yes",
      data: userType,
    });
  };

  // dynamic user type added permission module wise updated code
  const setEditViewAPI = (label, canEdit = true, canView = true) => ({
    label,
    Edit: canEdit,
    View: canView,
    API: canEdit
      ? apiMapping[label]?.["Edit"]
      : canView
      ? apiMapping[label]?.["View"]
      : "",
  });

  const modulesConfig = {
    DashboardMain: [
      "Dashboard Sales Revenue Report",
      "Dashboard Ageing Outstanding",
      "Schemes Metrics",
      "Warranty Registration Report",
    ],
    ProductMasters: [
      "Product Applications",
      "Category",
      "Sub Category",
      "Product Group",
      "Product Creation",
      "Spares Compatibility",
    ],
    Store: [
      "Stock Inward",
      "Stock Level",
      "Stock Details",
      "Stock Inward Log",
      "Stock Details Report",
      "ERP Stock Level",
      "ERP Stock Report",
      "Erp Stock Logs",
    ],
    Warehouse: ["Warehouse", "Warehouse Quick Login", "Dispatch List"],
    AdminTools: [
      "Users",
      "Create Franchise",
      "Franchise Type Report",
      "Rm Quick Login",
    ],
    Masters: ["States", "Cities", "Pincodes", "Box", "Couriers"],
    CRMTools: [
      "Region Master",
      "Purchase List",
      "Sales Person Performance",
      "Purchase Log List",
      "All Mail Listing",
    ],
    ReSells: [
      "Resellcycle Reports",
      "Resale Brands",
      "Settings",
      "Age Value",
      "Point List",
    ],
    DealerApp: [
      "Incentive Slab",
      "Schemes",
      "Tickets",
      "Help Desk Category",
      "Help Desk Sub Category",
      "Help Desk FAQ",
      "Notifications And CMS",
      "Marketing Campaigns",
    ],
    OrderManagement: [
      "All Orders Report",
      "SO Creation",
      "SO Approvals",
      "Warehouse Approvals",
      "Pending For Accounts",
      "Pending For Stores",
      "Pending For Dispatch",
      "Pending For Delivery",
      "Order Delivered",
      "Order Rejected",
      "Order Cancelled",
      "E-Invoice Details",
      "E-Invoice Cancel",
      "E-Way Bill Report",
      "Return And Replace List",
      "Erp Api Failures",
      "FBA Orders",
      "Re Assign warehouse",
      "Unicommerce Api Failures",
      "Upcoming Orders",
      "Draft Orders Report",
    ],
    AFSOrderManagement: [
      "After Sales Orders",
      "So Creations (AFS)",
      "Quotation Report",
      "AFS Order Sync",
      "Quotation Creation",
      "Payment Approval Pending",
    ],
    PaymentManager: [
      "Account Ledger Report",
      "Debit Credit Notes",
      "Debit Credit Notes Report",
      "Payment Approval",
      "Gst Data Report",
      "Erp Outstanding Report",
      "Erp General Outstanding Report",
      "Dealer Payment Approval",
      "Franchise Report",
    ],
    DealerAppOnly: [
      "Regular Order List",
      "Spares Order List",
      "Ledger",
      "Ticket Creation",
    ],
    D2C: ["D2C Dashboard"],
    Warranty: [
      "Warranty Assure Plans",
      "Warranty Operations",
      "Warranty Review Queue",
      "Warranty View Only",
    ],
  };

  const modulesState = {};

  Object.keys(modulesConfig).forEach((moduleKey) => {
    // D2CActive is not read anywhere; keep it false as in the templates.
    modulesState[`${moduleKey}Active`] = moduleKey !== "D2C";
    modulesState[moduleKey] = modulesConfig[moduleKey].map((label) => {
      // D2C can change dealer routing, and Warranty permissions are given to a person
      // deliberately in the permission window: no user type gets either by default.
      if (moduleKey === "D2C" || moduleKey === "Warranty") {
        return setEditViewAPI(label, false, false);
      }
      if (ApplicationState?.UserType === "admin") {
        if (
          label !== "Regular Order List" &&
          label !== "Spares Order List" &&
          label !== "Ledger" &&
          label !== "Ticket Creation"
        ) {
          return setEditViewAPI(label, true, true);
        } else {
          return setEditViewAPI(label, false, false);
        }
      } else if (ApplicationState?.UserType === "sales_operations") {
        if (moduleKey === "DealerApp" || moduleKey === "DealerAppOnly") {
          return setEditViewAPI(label, false, false);
        } else {
          return setEditViewAPI(label, true, true);
        }
      } else if (ApplicationState?.UserType === "warehouse_manager") {
        if (
          label === "Regular Order List" ||
          label === "Spares Order List" ||
          label === "Ledger" ||
          label === "Ticket Creation"
        ) {
          return setEditViewAPI(label, false, false);
        } else {
          if (
            label === "Stock Level" ||
            label === "Warehouse Approvals" ||
            label === "Pending For Stores" ||
            label === "Pending For Dispatch" ||
            label === "Pending For Delivery" ||
            label === "Order Delivered" ||
            label === "Order Rejected" ||
            label === "Order Cancelled"
          ) {
            return setEditViewAPI(label, true, true);
          } else {
            return setEditViewAPI(label, false, false);
          }
        }
      } else if (
        ApplicationState?.UserType === "inventory_operations" ||
        ApplicationState?.UserType === "logistics_ops"
      ) {
        if (moduleKey === "OrderManagement" || moduleKey === "PaymentManager") {
          return setEditViewAPI(label, true, true);
        } else if (moduleKey === "DealerApp" || moduleKey === "DealerAppOnly") {
          return setEditViewAPI(label, false, false);
        } else {
          return setEditViewAPI(label, false, true);
        }
      }
        else if (
        ApplicationState?.UserType === "warehouse_manager" ||
        ApplicationState?.UserType === "regional_manager" || 
        ApplicationState?.UserType === "regional_sales_team_rm" ||
        ApplicationState?.UserType === "regional_sales_team_asm"
      ) {
        if (label === "Draft Orders Report") {
          return setEditViewAPI(label, false, true);
        }
      }
        else if (ApplicationState?.UserType === "accounts") {
        if (moduleKey === "OrderManagement" || moduleKey === "PaymentManager") {
          return setEditViewAPI(label, true, true);
        } else if (
          moduleKey === "CRMTools" ||
          moduleKey === "ReSells" ||
          moduleKey === "DealerApp" ||
          moduleKey === "DealerAppOnly"
        ) {
          return setEditViewAPI(label, false, false);
        } else {
          return setEditViewAPI(label, false, true);
        }
      } else if (ApplicationState?.UserType === "regional_sales_team") {
        if (
          label === "All Orders Report" ||
          label === "SO Creation" ||
          label === "Account Ledger Report"
        ) {
          return setEditViewAPI(label, true, true);
        } else {
          return setEditViewAPI(label, false, false);
        }
      } else if (
        ApplicationState?.UserType === "inside_sales" ||
        ApplicationState?.UserType === "ecommerce"
      ) {
        if (
          moduleKey === "CRMTools" ||
          moduleKey === "ReSells" ||
          moduleKey === "DealerApp" ||
          moduleKey === "DealerAppOnly"
        ) {
          return setEditViewAPI(label, false, false);
        } else {
          return setEditViewAPI(label, false, true);
        }
      } else if (ApplicationState?.UserType === "sale_franchise_person") {
        if (
          label === "Stock Details" ||
          label === "Stock Details Report" ||
          label === "States" ||
          label === "Cities" ||
          label === "Pincodes" ||
          label === "Regular Order List"
        ) {
          return setEditViewAPI(label, true, true);
        } else if (
          label === "Create Franchise" ||
          label === "Product Creation" ||
          label === "After Sales Orders" ||
          label === "Product Group" ||
          label === "Ledger" ||
          label === "Ticket Creation"
        ) {
          return setEditViewAPI(label, false, true);
        } else {
          return setEditViewAPI(label, false, false);
        }
      } else if (ApplicationState?.UserType === "after_sales_and_service") {
        if (label === "After Sales Orders" || label === "So Creations (AFS)") {
          return setEditViewAPI(label, true, true);
        } else {
          return setEditViewAPI(label, false, false);
        }
      } else {
        return setEditViewAPI(label, false, false);
      }
    });
  });

  useEffect(() => {
    if (ApplicationState?.UserType !== "") {
      if (ApplicationState?.UserType === "sale_franchise_person") {
        setModules({
          ...modules,
          Dashboard: {
            SalesRevenueReport: false,
            DealerPerformance: false,
            OrderFulfillment: false,
            DailyOrdersRGLKolkata: false,
            DailyOrdersRGLDelhi: false,
            DailyOrdersRGLBangalore: false,
            AllOrderSummery: false,
          },
          StockDetailsReportSendMailActive: false,
          ...modulesState,
          // Editing a user: changing the team must not quietly drop a warranty permission they hold.
          ...(roomId ? { Warranty: modules.Warranty } : {}),
        });
      } else {
        setModules({
          ...modules,
          Dashboard: {
            SalesRevenueReport: true,
            DealerPerformance: true,
            OrderFulfillment: true,
            DailyOrdersRGLKolkata: true,
            DailyOrdersRGLDelhi: true,
            DailyOrdersRGLBangalore: true,
            AllOrderSummery: true,
          },
          StockDetailsReportSendMailActive: false,
          ...modulesState,
          // Editing a user: changing the team must not quietly drop a warranty permission they hold.
          ...(roomId ? { Warranty: modules.Warranty } : {}),
        });
      }
    }
  }, [ApplicationState?.UserType]);

  useEffect(() => {
    if (roomId) {
      Dispatch(
        StartMainCommonLoader({
          url: "user_details",
          loader: true,
        })
      );

      let param = {
        transmit: "broadcast",
        url: "user_details",
        request: {
          userid: roomId,
        },
        DeviceId: device_id,
      };
      wsSend_request(websocket, param);
    }
  }, [websocket]);

  useEffect(() => {
    let param = {
      transmit: "broadcast",
      url: "user_list",
      request: {
        status: "",
        limit: 5000,
        page_no: 1,
        search: "",
      },
      DeviceId: device_id,
    };
    wsSend_request(websocket, param);
  }, [websocket]);

  useEffect(() => {
    if (LocationRoute === "edit-user") {
      if (
        CurrentData_ !== undefined &&
        Object?.keys(CurrentData_)?.length > 0
      ) {
        if (CurrentData_?.user_type === "regional_sales_team_asm") {
          setApplicationState({
            ...ApplicationState,
            FullName: CurrentData_?.full_name,
            Email: CurrentData_?.email,
            Mobile: CurrentData_?.mobile,
            Address:
              CurrentData_?.address === null ? "" : CurrentData_?.address,
            address2:
              CurrentData_?.address2 === null ? "" : CurrentData_?.address2,
            UserType:
              CurrentData_?.user_type === "regional_sales_team_asm" ||
              CurrentData_?.user_type === "regional_sales_team_rm"
                ? "regional_sales_team"
                : CurrentData_?.user_type,
            RelatedID: optionsRegion?.filter(
              (elm) => elm?.value === CurrentData_?.region_id
            )[0],
            Regional_manager: userlistAll
              .filter((ele) => ele.id === CurrentData_?.related_id)
              .map((item) => ({
                id: item.id,
                value: item.id,
                label: item.full_name,
              }))[0],
            RegionType:
              CurrentData_?.user_type === "regional_sales_team_asm"
                ? "assistant_sales_manager"
                : "regional_manager",
            Status: CurrentData_?.is_active,
          });

          if (CurrentData_?.related_id !== null) {
            seterrorRelatedID("");
          }
        } else if (
          CurrentData_?.user_type === "regional_sales_team_rm" ||
          CurrentData_?.user_type === "regional_manager"
        ) {
          setApplicationState({
            ...ApplicationState,
            FullName: CurrentData_?.full_name,
            Email: CurrentData_?.email,
            Mobile: CurrentData_?.mobile,
            Address:
              CurrentData_?.address === null ? "" : CurrentData_?.address,
            address2:
              CurrentData_?.address2 === null ? "" : CurrentData_?.address2,
            UserType:
              CurrentData_?.user_type === "regional_sales_team_asm" ||
              CurrentData_?.user_type === "regional_sales_team_rm"
                ? "regional_sales_team"
                : CurrentData_?.user_type,
            RelatedID: optionsRegion?.filter(
              (elm) => elm?.value === CurrentData_?.related_id
            )[0],
            // Regional_manager: userlistAll.filter((ele) => ele.id === CurrentData_?.related_id).map((item) => ({ id: item.id, value: item.id, label:item.full_name }))[0],
            RegionType:
              CurrentData_?.user_type === "regional_sales_team_asm"
                ? "assistant_sales_manager"
                : "regional_manager",
            Status: CurrentData_?.is_active,
          });

          if (CurrentData_?.related_id !== null) {
            seterrorRelatedID("");
          }
        } else if (CurrentData_?.user_type === "sale_franchise_person") {
          setApplicationState({
            ...ApplicationState,
            FullName:
              CurrentData_?.full_name === null ? "" : CurrentData_?.full_name,
            Email: CurrentData_?.email === null ? "" : CurrentData_?.email,
            Mobile: CurrentData_?.mobile,
            Address:
              CurrentData_?.address === null ? "" : CurrentData_?.address,
            address2:
              CurrentData_?.address2 === null ? "" : CurrentData_?.address2,
            UserType: CurrentData_?.user_type,
            RelatedID: optionsFranchise?.filter(
              (elm) => elm?.value === CurrentData_?.related_id
            )[0],
            Status: CurrentData_?.is_active,
            user_verification: CurrentData_?.user_verification,
          });
          setKYCState({
            ...KYCState,
            AccountNumber:
              CurrentData_?.kyc_details?.account_number === null
                ? ""
                : CurrentData_?.kyc_details?.account_number,
            IFSCCode:
              CurrentData_?.kyc_details?.ifsc === null
                ? ""
                : CurrentData_?.kyc_details?.ifsc,
            AadhaarNumber:
              CurrentData_?.kyc_details?.adhar_id === null
                ? ""
                : CurrentData_?.kyc_details?.adhar_id,
          });
          setBankVerifiedStatus(
            CurrentData_?.is_bank_verified === null
              ? ""
              : CurrentData_?.is_bank_verified
              ? "Verified"
              : "Unverified"
          );
          setAadharVerifiedStatus(
            CurrentData_?.is_adhar_verified === null
              ? ""
              : CurrentData_?.is_adhar_verified
              ? "Verified"
              : "Unverified"
          );

          if (CurrentData_?.related_id !== null) {
            seterrorRelatedID("");
          }
        } else if (CurrentData_?.user_type === "franchise_manager") {
          setApplicationState({
            ...ApplicationState,
            FullName: CurrentData_?.full_name,
            Email: CurrentData_?.email,
            Mobile: CurrentData_?.mobile,
            Address:
              CurrentData_?.address === null ? "" : CurrentData_?.address,
            address2:
              CurrentData_?.address2 === null ? "" : CurrentData_?.address2,
            UserType: CurrentData_?.user_type,
            RelatedID:
              CurrentData_?.related_id === null
                ? ""
                : CurrentData_?.user_type === "warehouse_manager"
                ? optionsWareHouse?.filter(
                    (elm) => elm?.value === CurrentData_?.related_id
                  )[0]
                : optionsRegion?.filter(
                    (elm) => elm?.value === CurrentData_?.related_id
                  )[0],
            user_verification: CurrentData_?.user_verification,
            Status: CurrentData_?.is_active,
          });
        } else {
          setApplicationState({
            ...ApplicationState,
            FullName: CurrentData_?.full_name,
            Email: CurrentData_?.email,
            Mobile: CurrentData_?.mobile,
            Address:
              CurrentData_?.address === null ? "" : CurrentData_?.address,
            address2:
              CurrentData_?.address2 === null ? "" : CurrentData_?.address2,
            UserType: CurrentData_?.user_type,
            RelatedID:
              CurrentData_?.related_id === null
                ? ""
                : CurrentData_?.user_type === "warehouse_manager"
                ? optionsWareHouse?.filter(
                    (elm) => elm?.value === CurrentData_?.related_id
                  )[0]
                : optionsRegion?.filter(
                    (elm) => elm?.value === CurrentData_?.related_id
                  )[0],
            Status: CurrentData_?.is_active,
          });
          if (CurrentData_?.related_id !== null) {
            seterrorRelatedID("");
          }
        }
        setTimeout(() => {
          updateModulesFromApi(
            CurrentData_?.permissions_access === null
              ? modules
              : CurrentData_?.permissions_access
          );
        }, 500);
      }
    }
  }, [CurrentData_]);

  // update permissions modules wise state function
  const updateModulesFromApi = (apiResponse) => {
    const {
      DashboardMain,
      Dashboard,
      ProductMasters,
      Store,
      AdminTools,
      Masters,
      Warehouse,
      CRMTools,
      ReSells,
      OrderManagement,
      AFSOrderManagement,
      PaymentManager,
      DealerApp,
      DealerAppOnly,
      D2C,
      Warranty,
      StockDetailsReportSendMailActive,
    } = apiResponse;

    setModules({
      ...modules,
      InventoryActive: false,
      ProductMastersActive: false,
      Dashboard: {
        SalesRevenueReport: Dashboard?.SalesRevenueReport,
        DealerPerformance: Dashboard?.DealerPerformance,
        OrderFulfillment: Dashboard?.OrderFulfillment,
        DailyOrdersRGLKolkata: Dashboard?.DailyOrdersRGLKolkata,
        DailyOrdersRGLDelhi: Dashboard?.DailyOrdersRGLDelhi,
        DailyOrdersRGLBangalore: Dashboard?.DailyOrdersRGLBangalore,
        AllOrderSummery: Dashboard?.AllOrderSummery,
      },
      DashboardMain: [
        createModule("Dashboard Sales Revenue Report", DashboardMain),
        createModule("Dashboard Ageing Outstanding", DashboardMain),
        createModule("Schemes Metrics", DashboardMain),
        createModule("Warranty Registration Report", DashboardMain),
      ],
      ProductMasters: [
        createModule("Product Applications", ProductMasters),
        createModule("Category", ProductMasters),
        createModule("Sub Category", ProductMasters),
        createModule("Product Group", ProductMasters),
        createModule("Product Creation", ProductMasters),
        createModule("Spares Compatibility", ProductMasters),
      ],
      StoreActive: false,
      StockDetailsReportSendMailActive: StockDetailsReportSendMailActive,
      Store: [
        createModule("Stock Inward", Store),
        createModule("Stock Level", Store),
        createModule("Stock Details", Store),
        createModule("Stock Inward Log", Store),
        createModule("Stock Details Report", Store),
        createModule("ERP Stock Level", Store),
        createModule("ERP Stock Report", Store),
        createModule("Erp Stock Logs", Store),
      ],
      WarehouseActive: false,
      Warehouse: [
        createModule("Warehouse", Warehouse),
        createModule("Warehouse Quick Login", Warehouse),
        createModule("Dispatch List", Warehouse),
      ],
      AdminToolsActive: false,
      AdminTools: [
        createModule("Users", AdminTools),
        createModule("Create Franchise", AdminTools),
        createModule("Franchise Type Report", AdminTools),
        createModule("Rm Quick Login", AdminTools),
      ],
      Masters: [
        createModule("States", Masters),
        createModule("Cities", Masters),
        createModule("Pincodes", Masters),
        createModule("Box", Masters),
        createModule("Couriers", Masters),
      ],
      CRMToolsActive: false,
      CRMTools: [
        createModule("Region Master", CRMTools),
        createModule("Purchase List", CRMTools),
        createModule("Sales Person Performance", CRMTools),
        createModule("Purchase Log List", CRMTools),
        createModule("All Mail Listing", CRMTools),
      ],
      ReSellsActive: false,
      ReSells: [
        createModule("Resellcycle Reports", ReSells),
        createModule("Resale Brands", ReSells),
        createModule("Settings", ReSells),
        createModule("Age Value", ReSells),
        createModule("Point List", ReSells),
      ],
      DealerAppActive: false,
      DealerApp: [
        createModule("Incentive Slab", DealerApp),
        createModule("Schemes", DealerApp),
        createModule("Tickets", DealerApp),
        createModule("Help Desk Category", DealerApp),
        createModule("Help Desk Sub Category", DealerApp),
        createModule("Help Desk FAQ", DealerApp),
        createModule("Notifications And CMS", DealerApp),
        createModule("Marketing Campaigns", DealerApp),
      ],
      OrderManagementActive: false,
      OrderManagement: [
        createModule("All Orders Report", OrderManagement),
        createModule("SO Creation", OrderManagement),
        createModule("SO Approvals", OrderManagement),
        createModule("Warehouse Approvals", OrderManagement),
        createModule("Pending For Accounts", OrderManagement),
        createModule("Pending For Stores", OrderManagement),
        createModule("Pending For Dispatch", OrderManagement),
        createModule("Pending For Delivery", OrderManagement),
        createModule("Order Delivered", OrderManagement),
        createModule("Order Rejected", OrderManagement),
        createModule("Order Cancelled", OrderManagement),
        createModule("E-Invoice Details", OrderManagement),
        createModule("E-Invoice Cancel", OrderManagement),
        createModule("E-Way Bill Report", OrderManagement),
        createModule("Return And Replace List", OrderManagement),
        createModule("Erp Api Failures", OrderManagement),
        createModule("FBA Orders", OrderManagement),
        createModule("Re Assign warehouse", OrderManagement),
        createModule("Unicommerce Api Failures", OrderManagement),
        createModule("Upcoming Orders", OrderManagement),
        createModule("Draft Orders Report", OrderManagement),
      ],
      AFSOrderManagement: [
        createModule("After Sales Orders", AFSOrderManagement),
        createModule("So Creations (AFS)", AFSOrderManagement),
        createModule("Quotation Report", AFSOrderManagement),
        createModule("AFS Order Sync", AFSOrderManagement),
        createModule("Quotation Creation", AFSOrderManagement),
        createModule("Payment Approval Pending", AFSOrderManagement),
      ],
      PaymentManagerActive: false,
      PaymentManager: [
        createModule("Account Ledger Report", PaymentManager),
        createModule("Debit Credit Notes", PaymentManager),
        createModule("Debit Credit Notes Report", PaymentManager),
        createModule("Payment Approval", PaymentManager),
        createModule("Gst Data Report", PaymentManager),
        createModule("Erp Outstanding Report", PaymentManager),
        createModule("Erp General Outstanding Report", PaymentManager),
        createModule("Dealer Payment Approval", PaymentManager),
        createModule("Franchise Report", PaymentManager),
      ],
      DealerAppOnly: [
        createModule("Regular Order List", DealerAppOnly),
        createModule("Spares Order List", DealerAppOnly),
        createModule("Ledger", DealerAppOnly),
        createModule("Ticket Creation", DealerAppOnly),
      ],
      D2CActive: false,
      D2C: [createModule("D2C Dashboard", D2C)],
      Warranty: [
        createWarrantyModule("Warranty Assure Plans", Warranty),
        createWarrantyModule("Warranty Operations", Warranty),
        createWarrantyModule("Warranty Review Queue", Warranty),
        createWarrantyModule("Warranty View Only", Warranty),
      ],
    });
  };

  // A user saved before the Warranty group existed has no Warranty entry in permissions_access,
  // but may already hold the permission in `permissions`. Read that list too, so opening and
  // saving the user does not drop it.
  const createWarrantyModule = (label, moduleData) => {
    const fromAccess = UpdateAPImoduels(label, moduleData);
    const permission = apiMapping[label]?.["Edit"];
    const granted =
      fromAccess?.Edit === true ||
      (Array.isArray(CurrentData_?.permissions) &&
        CurrentData_.permissions.some(
          (item) => typeof item === "string" && item.trim() === permission
        ));
    return {
      label,
      Edit: granted,
      View: granted,
      API: granted ? permission : "",
    };
  };

  const createModule = (label, moduleData) => ({
    label,
    Edit: UpdateAPImoduels(label, moduleData)?.Edit,
    View: UpdateAPImoduels(label, moduleData)?.View,
    API: UpdateAPImoduels(label, moduleData)?.API,
  });

  const UpdateAPImoduels = (url, data) => {
    const currentModule = data?.filter((elm) => elm?.label === url)[0];
    return currentModule;
  };

  // select user type
  const SelectUserType = (value) => {
    SelectRelatedType("", value);
    if (value !== "") {
      setApplicationState((ApplicationState) => ({
        ...ApplicationState,
        UserType: value,
        RegionType: "",
      }));
      seterrorUserType("");
      if (value === "regional_manager") {
        if (defaultRegionOption?.value !== undefined) {
          seterrorRelatedID("");
        }
      } else if (value === "warehouse_manager") {
        if (defaultWareHouseOption?.value !== undefined) {
          seterrorRelatedID("");
        }
      } else if (value === "sale_franchise_person") {
        if (defaultFranchiseOption?.value !== undefined) {
          seterrorRelatedID("");
        }
      } else if (value === "regional_sales_team") {
        if (defaultFranchiseOption?.value !== undefined) {
          seterrorerrorRegionalType("");
        } else {
          seterrorerrorRegionalType("Please select type");
        }
      }
    } else {
      setApplicationState((ApplicationState) => ({
        ...ApplicationState,
        UserType: value,
      }));
      seterrorUserType("Please select user team");
    }
  };

  // select region
  const SelectRelatedType = (value, url) => {
    if (value !== "" && value !== null) {
      setApplicationState({
        ...ApplicationState,
        RelatedID: value,
        Regional_manager: "",
      });
      seterrorRelatedID("");
    } else {
      setApplicationState((data) => ({
        ...data,
        RelatedID: "",
        Regional_manager: "",
      }));
      if (url === "regional manager" || url === "regional_sales_team") {
        seterrorRelatedID(`Please select region`);
      } else {
        if (url === "sale_franchise_person") {
          seterrorRelatedID(`Please select franchise master`);
        } else {
          seterrorRelatedID(`Please select ${url?.replaceAll("_", " ")}`);
        }
      }
    }
  };

  // select region type
  const SelectRegionalType = (value) => {
    if (value !== "" && value !== null) {
      setApplicationState({
        ...ApplicationState,
        RegionType: value,
        RelatedID: "",
      });
      seterrorerrorRegionalType("");
    } else {
      setApplicationState({
        ...ApplicationState,
        RegionType: "",
        RelatedID: "",
      });
      seterrorerrorRegionalType("Please select type");
    }
  };

  useEffect(() => {
    if (ApplicationState?.RegionType !== "regional_manager") {
      if (
        ApplicationState?.RelatedID !== "" &&
        ApplicationState?.RelatedID !== null &&
        ApplicationState?.RelatedID !== undefined
      ) {
        SetoptionsRegionalManager(
          userlistAll
            .filter(
              (ele) =>
                ele.related_id === ApplicationState.RelatedID.value &&
                ele?.is_active
            )
            .map((item) => ({
              id: item.id,
              value: item.id,
              label: item.full_name,
            }))
        );
      } else {
        SetoptionsRegionalManager([]);
      }
    }
  }, [ApplicationState?.RelatedID, userlistAll]);

  const SelectRegionalManager = (value) => {
    if (value != "" && value !== null) {
      setApplicationState({ ...ApplicationState, Regional_manager: value });
      setErrorRegionalManager("");
    } else {
      setApplicationState({ ...ApplicationState, Regional_manager: "" });
      setErrorRegionalManager("Please select regional manager");
    }
  };

  useEffect(() => {
    if (uniqueAPIs?.length > 0 || CheckDashboardPermissions) {
      setpermissionsError("");
    } else {
      // setpermissionsError("Please select permissions");
    }
  }, [uniqueAPIs]);

  const PhoneCode = 91;
  const CountryStates = getRegionCodeForCountryCode(PhoneCode);
  const CheckMobileNumber = parsePhoneNumber(
    ApplicationState?.Mobile?.toString(),
    { regionCode: CountryStates }
  );

  // check Dashboard permissions
  const CheckDashboardPermissions =
    Object?.keys(modules)?.length > 0 &&
    Object?.values(modules?.Dashboard)?.filter((elm) => elm === true)?.length >
      0;

  // create user and edit user
  const CreateUser = () => {
    if (LocationRoute === "edit-user") {
      if (ApplicationState.UserType !== "admin") {
        if (
          ApplicationState.UserType === "regional_sales_team" &&
          ApplicationState.RegionType === "assistant_sales_manager"
        ) {
          if (
            ApplicationState?.FullName.trim() !== "" &&
            ApplicationState?.Mobile.trim() !== "" &&
            ApplicationState?.Regional_manager !== "" &&
            ApplicationState?.UserType !== "" &&
            ApplicationState?.RelatedID !== "" &&
            ApplicationState?.Email.trim() !== "" &&
            ApplicationState?.Address.length <= 300 &&
            ApplicationState?.address2?.length <= 300 &&
            (uniqueAPIs?.length > 0 || CheckDashboardPermissions)
          ) {
            if (
              EmailRegex.test(ApplicationState?.Email) === true &&
              CheckMobileNumber?.valid === true
            ) {
              Dispatch(
                StartMainCommonLoader({
                  url: "user_edit",
                  loader: true,
                })
              );
              let param = {
                transmit: "broadcast",
                url: "user_edit",
                request: {
                  userid: CurrentData_?.id,
                  full_name: ApplicationState?.FullName,
                  email: ApplicationState?.Email,
                  mobile: ApplicationState?.Mobile,
                  address: ApplicationState?.Address,
                  address2: ApplicationState?.address2,
                  user_type:
                    ApplicationState?.RegionType === "regional_manager"
                      ? ApplicationState?.UserType + "_rm"
                      : ApplicationState?.UserType + "_asm",
                  permissions: uniqueAPIs,
                  permissions_access: modules,
                  related_id:
                    ApplicationState?.RegionType === "regional_manager"
                      ? ApplicationState?.RelatedID?.value
                      : ApplicationState?.Regional_manager?.value,
                  is_active: ApplicationState?.Status,
                },
                DeviceId: device_id,
              };
              wsSend_request(websocket, param);
            } else {
              CheckValid(ApplicationState?.Mobile, {
                type: "phone",
                error: seterrorMobile,
              });
              CheckValid(ApplicationState?.Email.trim(), {
                type: "email",
                error: seterrorEmail,
              });
            }
          } else {
            CheckValid(ApplicationState?.Mobile, {
              type: "phone",
              error: seterrorMobile,
            });
            CheckValid(ApplicationState?.FullName.trim(), {
              type: "FullName",
              error: seterrorFirstName,
            });
            CheckValid(ApplicationState?.Email.trim(), {
              type: "email",
              error: seterrorEmail,
            });
            if (ApplicationState?.Address.length > 300) {
              CheckValid(ApplicationState?.Address.trim(), {
                type: "Address",
                error: seterrorAddress,
              });
            }
            if (ApplicationState?.address2?.length > 300) {
              CheckValid(ApplicationState?.address2?.trim(), {
                type: "address2",
                error: seterrorAddress2,
              });
            }
            if (ApplicationState?.UserType === "") {
              seterrorUserType("Please select user team");
            } else {
              seterrorUserType("");
            }
            if (ApplicationState?.RelatedID === "") {
              if (
                ApplicationState.UserType === "regional_sales_team" &&
                ApplicationState.RegionType === "assistant_sales_manager"
              ) {
                seterrorRelatedID(`Please select region`);
              } else {
                if (ApplicationState?.UserType === "sale_franchise_person") {
                  seterrorRelatedID(`Please select franchise master`);
                } else {
                  seterrorRelatedID(
                    `Please select ${ApplicationState?.UserType?.replaceAll(
                      "_",
                      " "
                    )}`
                  );
                }
              }
            } else {
              seterrorRelatedID("");
            }
            if (ApplicationState?.Regional_manager === "") {
              setErrorRegionalManager("Please select regional manager");
            } else {
              setErrorRegionalManager("");
            }
            if (uniqueAPIs?.length > 0 || CheckDashboardPermissions) {
              setpermissionsError("");
            } else {
              setpermissionsError("Please select permissions");
            }
          }
        } else if (
          ApplicationState.UserType === "regional_sales_team" &&
          ApplicationState.RegionType === "regional_manager"
        ) {
          if (
            ApplicationState?.FullName.trim() !== "" &&
            ApplicationState?.Mobile.trim() !== "" &&
            ApplicationState?.UserType !== "" &&
            ApplicationState?.RelatedID !== "" &&
            ApplicationState?.Email.trim() !== "" &&
            ApplicationState?.Address.length <= 300 &&
            ApplicationState?.address2?.length <= 300 &&
            (uniqueAPIs?.length > 0 || CheckDashboardPermissions)
          ) {
            if (
              EmailRegex.test(ApplicationState?.Email) === true &&
              CheckMobileNumber?.valid === true
            ) {
              Dispatch(
                StartMainCommonLoader({
                  url: "user_edit",
                  loader: true,
                })
              );
              let param = {
                transmit: "broadcast",
                url: "user_edit",
                request: {
                  userid: CurrentData_?.id,
                  full_name: ApplicationState?.FullName,
                  email: ApplicationState?.Email,
                  mobile: ApplicationState?.Mobile,
                  address: ApplicationState?.Address,
                  address2: ApplicationState?.address2,
                  user_type:
                    ApplicationState?.RegionType === "regional_manager"
                      ? ApplicationState?.UserType + "_rm"
                      : ApplicationState?.UserType + "_asm",
                  permissions: uniqueAPIs,
                  permissions_access: modules,
                  related_id:
                    ApplicationState?.RegionType === "regional_manager"
                      ? ApplicationState?.RelatedID?.value
                      : ApplicationState?.Regional_manager?.value,
                  is_active: ApplicationState?.Status,
                },
                DeviceId: device_id,
              };
              wsSend_request(websocket, param);
            } else {
              CheckValid(ApplicationState?.Mobile, {
                type: "phone",
                error: seterrorMobile,
              });
              CheckValid(ApplicationState?.Email.trim(), {
                type: "email",
                error: seterrorEmail,
              });
            }
          } else {
            CheckValid(ApplicationState?.Mobile, {
              type: "phone",
              error: seterrorMobile,
            });
            CheckValid(ApplicationState?.FullName.trim(), {
              type: "FullName",
              error: seterrorFirstName,
            });
            CheckValid(ApplicationState?.Email.trim(), {
              type: "email",
              error: seterrorEmail,
            });
            if (ApplicationState?.Address.length > 300) {
              CheckValid(ApplicationState?.Address.trim(), {
                type: "Address",
                error: seterrorAddress,
              });
            }
            if (ApplicationState?.address2?.length > 300) {
              CheckValid(ApplicationState?.address2?.trim(), {
                type: "address2",
                error: seterrorAddress2,
              });
            }
            if (ApplicationState?.UserType === "") {
              seterrorUserType("Please select user team");
            } else {
              seterrorUserType("");
            }
            if (ApplicationState?.RelatedID === "") {
              if (
                ApplicationState.UserType === "regional_sales_team" &&
                ApplicationState.RegionType === "regional_manager"
              ) {
                seterrorRelatedID(`Please select region`);
              } else {
                if (ApplicationState?.UserType === "sale_franchise_person") {
                  seterrorRelatedID(`Please select franchise master`);
                } else {
                  seterrorRelatedID(
                    `Please select ${ApplicationState?.UserType?.replaceAll(
                      "_",
                      " "
                    )}`
                  );
                }
              }
            } else {
              seterrorRelatedID("");
            }
            if (uniqueAPIs?.length > 0 || CheckDashboardPermissions) {
              setpermissionsError("");
            } else {
              setpermissionsError("Please select permissions");
            }
          }
        } else if (ApplicationState.UserType === "sale_franchise_person") {
          if (
            ApplicationState?.FullName?.trim() !== "" &&
            ApplicationState?.Mobile?.trim() !== "" &&
            ApplicationState?.UserType !== "" &&
            ApplicationState?.RelatedID !== "" &&
            ApplicationState?.Email?.trim() !== "" &&
            KYCState.AccountNumber !== "" &&
            KYCState.IFSCCode !== "" &&
            BankVerifiedStatus === "Verified" &&
            KYCState?.AadhaarNumber !== "" &&
            ApplicationState?.Address.length <= 300 &&
            ApplicationState?.address2?.length <= 300 &&
            (uniqueAPIs?.length > 0 || CheckDashboardPermissions)
          ) {
            if (
              EmailRegex.test(ApplicationState?.Email) === true &&
              CheckMobileNumber?.valid === true
            ) {
              Dispatch(
                StartMainCommonLoader({
                  url: "user_edit",
                  loader: true,
                })
              );
              let param = {
                transmit: "broadcast",
                url: "user_edit",
                request: {
                  userid: CurrentData_?.id,
                  full_name: ApplicationState?.FullName,
                  email: ApplicationState?.Email,
                  mobile: ApplicationState?.Mobile,
                  address: ApplicationState?.Address,
                  address2: ApplicationState?.address2,
                  user_type: ApplicationState?.UserType,
                  permissions: uniqueAPIs,
                  permissions_access: modules,
                  related_id: ApplicationState?.RelatedID?.value,
                  is_bank_verified:
                    BankVerifiedStatus === "Verified" ? true : false,
                  account_holder_name: KYCState?.AccountHolderName,
                  bank_name: KYCState?.AccountBankName,
                  account_number: KYCState?.AccountNumber,
                  ifsc_code: KYCState?.IFSCCode,
                  is_adhar_verified:
                    AadharVerifiedStatus === "Verified" ? true : false,
                  adhar_id: KYCState?.AadhaarNumber,
                  is_active: ApplicationState?.Status,
                  user_verification: ApplicationState?.user_verification,
                },
                DeviceId: device_id,
              };
              wsSend_request(websocket, param);
            } else {
              CheckValid(ApplicationState?.Mobile, {
                type: "phone",
                error: seterrorMobile,
              });
              CheckValid(ApplicationState?.Email.trim(), {
                type: "email",
                error: seterrorEmail,
              });
            }
          } else {
            CheckValid(ApplicationState?.Mobile, {
              type: "phone",
              error: seterrorMobile,
            });
            CheckValid(ApplicationState?.FullName?.trim(), {
              type: "FullName",
              error: seterrorFirstName,
            });
            CheckValid(ApplicationState?.Email?.trim(), {
              type: "email",
              error: seterrorEmail,
            });

            if (ApplicationState?.Address.length > 300) {
              CheckValid(ApplicationState?.Address.trim(), {
                type: "Address",
                error: seterrorAddress,
              });
            }
            if (ApplicationState?.address2?.length > 300) {
              CheckValid(ApplicationState?.address2?.trim(), {
                type: "address2",
                error: seterrorAddress2,
              });
            }
            if (ApplicationState?.UserType === "") {
              seterrorUserType("Please select user team");
            } else {
              seterrorUserType("");
            }
            if (ApplicationState?.RelatedID === "") {
              if (
                ApplicationState.UserType === "regional_sales_team" &&
                ApplicationState.RegionType === "regional_manager"
              ) {
                seterrorRelatedID(`Please select region`);
              } else {
                if (ApplicationState?.UserType === "sale_franchise_person") {
                  seterrorRelatedID(`Please select franchise master`);
                } else {
                  seterrorRelatedID(
                    `Please select ${ApplicationState?.UserType?.replaceAll(
                      "_",
                      " "
                    )}`
                  );
                }
              }
            } else {
              seterrorRelatedID("");
            }
            if (uniqueAPIs?.length > 0 || CheckDashboardPermissions) {
              setpermissionsError("");
            } else {
              setpermissionsError("Please select permissions");
            }
            CheckValid(KYCState?.AccountNumber, {
              type: "AccountNumber",
              error: setErrorAccountNumber,
            });
            CheckValid(KYCState.IFSCCode, {
              type: "IFSCCode",
              error: setErrorIFSCcodeNumber,
            });
            CheckValid(KYCState?.AadhaarNumber, {
              type: "AadhaarNumber",
              error: setErrorAadhaarNumber,
            });
          }
        } else if (
          ApplicationState.UserType === "sales_operations" ||
          ApplicationState?.UserType === "inventory_operations" ||
          ApplicationState?.UserType === "logistics_ops" ||
          ApplicationState?.UserType === "accounts" ||
          ApplicationState?.UserType === "inside_sales" ||
          ApplicationState?.UserType === "ecommerce"
        ) {
          if (
            ApplicationState?.FullName.trim() !== "" &&
            ApplicationState?.Mobile.trim() !== "" &&
            ApplicationState?.UserType !== "" &&
            ApplicationState?.Email.trim() !== "" &&
            ApplicationState?.Address.length <= 300 &&
            ApplicationState?.address2?.length <= 300 &&
            (uniqueAPIs?.length > 0 || CheckDashboardPermissions)
          ) {
            if (
              EmailRegex.test(ApplicationState?.Email) === true &&
              CheckMobileNumber?.valid === true
            ) {
              Dispatch(
                StartMainCommonLoader({
                  url: "user_edit",
                  loader: true,
                })
              );
              let param = {
                transmit: "broadcast",
                url: "user_edit",
                request: {
                  userid: CurrentData_?.id,
                  full_name: ApplicationState?.FullName,
                  email: ApplicationState?.Email,
                  mobile: ApplicationState?.Mobile,
                  address: ApplicationState?.Address,
                  address2: ApplicationState?.address2,
                  user_type: ApplicationState?.UserType,
                  permissions: uniqueAPIs,
                  permissions_access: modules,
                  is_active: ApplicationState?.Status,
                },
                DeviceId: device_id,
              };
              wsSend_request(websocket, param);
            } else {
              CheckValid(ApplicationState?.Mobile, {
                type: "phone",
                error: seterrorMobile,
              });
              CheckValid(ApplicationState?.Email.trim(), {
                type: "email",
                error: seterrorEmail,
              });
            }
          } else {
            CheckValid(ApplicationState?.Mobile, {
              type: "phone",
              error: seterrorMobile,
            });
            CheckValid(ApplicationState?.FullName.trim(), {
              type: "FullName",
              error: seterrorFirstName,
            });
            CheckValid(ApplicationState?.Email.trim(), {
              type: "email",
              error: seterrorEmail,
            });
            if (ApplicationState?.Address.length > 300) {
              CheckValid(ApplicationState?.Address.trim(), {
                type: "Address",
                error: seterrorAddress,
              });
            }
            if (ApplicationState?.address2?.length > 300) {
              CheckValid(ApplicationState?.address2?.trim(), {
                type: "address2",
                error: seterrorAddress2,
              });
            }
            if (ApplicationState?.UserType === "") {
              seterrorUserType("Please select user team");
            } else {
              seterrorUserType("");
            }
            if (ApplicationState?.RelatedID === "") {
              if (
                ApplicationState.UserType === "regional_sales_team" &&
                ApplicationState.RegionType === "regional_manager"
              ) {
                seterrorRelatedID(`Please select region`);
              } else {
                if (ApplicationState?.UserType === "sale_franchise_person") {
                  seterrorRelatedID(`Please select franchise master`);
                } else {
                  seterrorRelatedID(
                    `Please select ${ApplicationState?.UserType?.replaceAll(
                      "_",
                      " "
                    )}`
                  );
                }
              }
            } else {
              seterrorRelatedID("");
            }
            if (uniqueAPIs?.length > 0 || CheckDashboardPermissions) {
              setpermissionsError("");
            } else {
              setpermissionsError("Please select permissions");
            }
          }
        } else if (ApplicationState.UserType === "franchise_manager") {
          Dispatch(
            StartMainCommonLoader({
              url: "user_edit",
              loader: true,
            })
          );
          let param = {
            transmit: "broadcast",
            url: "user_edit",
            request: {
              userid: CurrentData_?.id,
              full_name: ApplicationState?.FullName,
              email: ApplicationState?.Email,
              mobile: ApplicationState?.Mobile,
              address: ApplicationState?.Address,
              address2: ApplicationState?.address2,
              user_type: CurrentData_?.user_type,
              related_id: CurrentData_?.related_id,
              permissions: CurrentData_?.permissions,
              permissions_access: null,
              user_verification: ApplicationState?.user_verification,
              is_active: ApplicationState?.Status,
            },
            DeviceId: device_id,
          };
          wsSend_request(websocket, param);
        } else if (ApplicationState.UserType === "after_sales_and_service") {
          if (
            ApplicationState?.FullName.trim() !== "" &&
            ApplicationState?.Mobile.trim() !== "" &&
            ApplicationState?.UserType !== "" &&
            ApplicationState?.Email.trim() !== "" &&
            ApplicationState?.Address.length <= 300 &&
            ApplicationState?.address2?.length <= 300 &&
            (uniqueAPIs?.length > 0 || CheckDashboardPermissions)
          ) {
            if (
              EmailRegex.test(ApplicationState?.Email) === true &&
              CheckMobileNumber?.valid === true
            ) {
              Dispatch(
                StartMainCommonLoader({
                  url: "user_edit",
                  loader: true,
                })
              );
              let param = {
                transmit: "broadcast",
                url: "user_edit",
                request: {
                  userid: CurrentData_?.id,
                  full_name: ApplicationState?.FullName,
                  email: ApplicationState?.Email,
                  mobile: ApplicationState?.Mobile,
                  address: ApplicationState?.Address,
                  address2: ApplicationState?.address2,
                  user_type: ApplicationState?.UserType,
                  permissions: uniqueAPIs,
                  permissions_access: modules,
                  is_active: ApplicationState?.Status,
                },
                DeviceId: device_id,
              };
              wsSend_request(websocket, param);
            } else {
              CheckValid(ApplicationState?.Mobile, {
                type: "phone",
                error: seterrorMobile,
              });
              CheckValid(ApplicationState?.Email.trim(), {
                type: "email",
                error: seterrorEmail,
              });
            }
          } else {
            CheckValid(ApplicationState?.Mobile, {
              type: "phone",
              error: seterrorMobile,
            });
            CheckValid(ApplicationState?.FullName.trim(), {
              type: "FullName",
              error: seterrorFirstName,
            });
            CheckValid(ApplicationState?.Email.trim(), {
              type: "email",
              error: seterrorEmail,
            });

            if (ApplicationState?.Address.length > 300) {
              CheckValid(ApplicationState?.Address.trim(), {
                type: "Address",
                error: seterrorAddress,
              });
            }
            if (ApplicationState?.address2?.length > 300) {
              CheckValid(ApplicationState?.address2?.trim(), {
                type: "address2",
                error: seterrorAddress2,
              });
            }
            if (ApplicationState?.UserType === "") {
              seterrorUserType("Please select user team");
            } else {
              seterrorUserType("");
            }
            if (uniqueAPIs?.length > 0 || CheckDashboardPermissions) {
              setpermissionsError("");
            } else {
              setpermissionsError("Please select permissions");
            }
          }
        } else {
          if (
            ApplicationState?.FullName.trim() !== "" &&
            ApplicationState?.Mobile.trim() !== "" &&
            ApplicationState?.UserType !== "" &&
            ApplicationState?.RelatedID !== "" &&
            ApplicationState?.Email.trim() !== "" &&
            ApplicationState?.Address.length <= 300 &&
            ApplicationState?.address2?.length <= 300 &&
            (uniqueAPIs?.length > 0 || CheckDashboardPermissions)
          ) {
            if (
              EmailRegex.test(ApplicationState?.Email) === true &&
              CheckMobileNumber?.valid === true
            ) {
              Dispatch(
                StartMainCommonLoader({
                  url: "user_edit",
                  loader: true,
                })
              );
              let param = {
                transmit: "broadcast",
                url: "user_edit",
                request: {
                  userid: CurrentData_?.id,
                  full_name: ApplicationState?.FullName,
                  email: ApplicationState?.Email,
                  mobile: ApplicationState?.Mobile,
                  address: ApplicationState?.Address,
                  address2: ApplicationState?.address2,
                  user_type: ApplicationState?.UserType,
                  permissions: uniqueAPIs,
                  permissions_access: modules,
                  related_id: ApplicationState?.RelatedID?.value,
                  is_active: ApplicationState?.Status,
                },
                DeviceId: device_id,
              };
              wsSend_request(websocket, param);
            } else {
              CheckValid(ApplicationState?.Mobile, {
                type: "phone",
                error: seterrorMobile,
              });
              CheckValid(ApplicationState?.Email.trim(), {
                type: "email",
                error: seterrorEmail,
              });
            }
          } else {
            CheckValid(ApplicationState?.Mobile, {
              type: "phone",
              error: seterrorMobile,
            });
            CheckValid(ApplicationState?.FullName.trim(), {
              type: "FullName",
              error: seterrorFirstName,
            });
            CheckValid(ApplicationState?.Email.trim(), {
              type: "email",
              error: seterrorEmail,
            });
            if (ApplicationState?.Address.length > 300) {
              CheckValid(ApplicationState?.Address.trim(), {
                type: "Address",
                error: seterrorAddress,
              });
            }
            if (ApplicationState?.address2?.length > 300) {
              CheckValid(ApplicationState?.address2?.trim(), {
                type: "address2",
                error: seterrorAddress2,
              });
            }
            if (ApplicationState?.UserType === "") {
              seterrorUserType("Please select user team");
            } else {
              seterrorUserType("");
            }
            if (ApplicationState?.RelatedID === "") {
              if (ApplicationState?.UserType === "sale_franchise_person") {
                seterrorRelatedID(`Please select franchise master`);
              } else {
                seterrorRelatedID(
                  `Please select ${ApplicationState?.UserType?.replaceAll(
                    "_",
                    " "
                  )}`
                );
              }
            } else {
              seterrorRelatedID("");
            }
            if (uniqueAPIs?.length > 0 || CheckDashboardPermissions) {
              setpermissionsError("");
            } else {
              setpermissionsError("Please select permissions");
            }
          }
        }
      } else {
        if (
          ApplicationState?.FullName.trim() !== "" &&
          ApplicationState?.Mobile.trim() !== "" &&
          ApplicationState?.UserType !== "" &&
          ApplicationState?.Email.trim() !== "" &&
          ApplicationState?.Address.length <= 300 &&
          ApplicationState?.address2?.length <= 300 &&
          (uniqueAPIs?.length > 0 || CheckDashboardPermissions)
        ) {
          if (
            EmailRegex.test(ApplicationState?.Email) === true &&
            CheckMobileNumber?.valid === true
          ) {
            Dispatch(
              StartMainCommonLoader({
                url: "user_edit",
                loader: true,
              })
            );
            let param = {
              transmit: "broadcast",
              url: "user_edit",
              request: {
                userid: CurrentData_?.id,
                full_name: ApplicationState?.FullName,
                email: ApplicationState?.Email,
                mobile: ApplicationState?.Mobile,
                address: ApplicationState?.Address,
                address2: ApplicationState?.address2,
                user_type: ApplicationState?.UserType,
                permissions: uniqueAPIs,
                permissions_access: modules,
                is_active: ApplicationState?.Status,
              },
              DeviceId: device_id,
            };
            wsSend_request(websocket, param);
          } else {
            CheckValid(ApplicationState?.Mobile, {
              type: "phone",
              error: seterrorMobile,
            });
            CheckValid(ApplicationState?.Email.trim(), {
              type: "email",
              error: seterrorEmail,
            });
          }
        } else {
          CheckValid(ApplicationState?.Mobile, {
            type: "phone",
            error: seterrorMobile,
          });
          CheckValid(ApplicationState?.FullName.trim(), {
            type: "FullName",
            error: seterrorFirstName,
          });
          CheckValid(ApplicationState?.Email.trim(), {
            type: "email",
            error: seterrorEmail,
          });
          if (ApplicationState?.Address.length > 300) {
            CheckValid(ApplicationState?.Address.trim(), {
              type: "Address",
              error: seterrorAddress,
            });
          }
          if (ApplicationState?.address2?.length > 300) {
            CheckValid(ApplicationState?.address2?.trim(), {
              type: "address2",
              error: seterrorAddress2,
            });
          }
          if (ApplicationState?.UserType === "") {
            seterrorUserType("Please select user team");
          } else {
            seterrorUserType("");
          }
          if (uniqueAPIs?.length > 0 || CheckDashboardPermissions) {
            setpermissionsError("");
          } else {
            setpermissionsError("Please select permissions");
          }
        }
      }
    } else {
      if (ApplicationState.UserType !== "admin") {
        if (
          ApplicationState.UserType === "regional_sales_team" &&
          ApplicationState.RegionType === "assistant_sales_manager"
        ) {
          if (
            ApplicationState?.FullName.trim() !== "" &&
            ApplicationState?.Mobile.trim() !== "" &&
            ApplicationState?.UserType !== "" &&
            ApplicationState?.RelatedID !== "" &&
            ApplicationState?.Email.trim() !== "" &&
            ApplicationState?.Address.length <= 300 &&
            ApplicationState?.address2?.length <= 300 &&
            ApplicationState?.RegionType !== "" &&
            ApplicationState?.Regional_manager !== "" &&
            (uniqueAPIs?.length > 0 || CheckDashboardPermissions)
          ) {
            if (
              EmailRegex.test(ApplicationState?.Email) === true &&
              CheckMobileNumber?.valid === true
            ) {
              Dispatch(
                StartMainCommonLoader({
                  url: "user_add",
                  loader: true,
                })
              );
              let param = {
                transmit: "broadcast",
                url: "user_add",
                request: {
                  full_name: ApplicationState?.FullName,
                  email: ApplicationState?.Email,
                  mobile: ApplicationState?.Mobile,
                  address: ApplicationState?.Address,
                  address2: ApplicationState?.address2,
                  user_type:
                    ApplicationState?.RegionType === "regional_manager"
                      ? ApplicationState?.UserType + "_rm"
                      : ApplicationState?.UserType + "_asm",
                  permissions: uniqueAPIs,
                  permissions_access: modules,
                  related_id:
                    ApplicationState?.RegionType === "regional_manager"
                      ? ApplicationState?.RelatedID?.value
                      : ApplicationState?.Regional_manager?.value,
                  is_active: ApplicationState?.Status,
                },
                DeviceId: device_id,
              };
              wsSend_request(websocket, param);
            } else {
              CheckValid(ApplicationState?.Mobile, {
                type: "phone",
                error: seterrorMobile,
              });
              CheckValid(ApplicationState?.Email.trim(), {
                type: "email",
                error: seterrorEmail,
              });
            }
          } else {
            if (ApplicationState?.Address.length > 300) {
              CheckValid(ApplicationState?.Address.trim(), {
                type: "Address",
                error: seterrorAddress,
              });
            }
            if (ApplicationState?.address2?.length > 300) {
              CheckValid(ApplicationState?.address2?.trim(), {
                type: "address2",
                error: seterrorAddress2,
              });
            }
            CheckValid(ApplicationState?.Mobile, {
              type: "phone",
              error: seterrorMobile,
            });
            CheckValid(ApplicationState?.FullName.trim(), {
              type: "FullName",
              error: seterrorFirstName,
            });
            CheckValid(ApplicationState?.Email.trim(), {
              type: "email",
              error: seterrorEmail,
            });
            if (ApplicationState?.RegionType === "") {
              seterrorerrorRegionalType("Please select type");
            } else {
              seterrorerrorRegionalType("");
            }
            if (ApplicationState?.Regional_manager === "") {
              setErrorRegionalManager("Please select regional manager");
            } else {
              setErrorRegionalManager("");
            }
            if (ApplicationState?.UserType === "") {
              seterrorUserType("Please select user team");
            } else {
              seterrorUserType("");
            }
            if (ApplicationState?.RelatedID === "") {
              if (
                ApplicationState.UserType === "regional_sales_team" &&
                ApplicationState.RegionType === "assistant_sales_manager"
              ) {
                seterrorRelatedID(`Please select region`);
              } else {
                if (ApplicationState?.UserType === "sale_franchise_person") {
                  seterrorRelatedID(`Please select franchise master`);
                } else {
                  seterrorRelatedID(
                    `Please select ${ApplicationState?.UserType?.replaceAll(
                      "_",
                      " "
                    )}`
                  );
                }
              }
            } else {
              seterrorRelatedID("");
            }
            if (ApplicationState?.Regional_manager === "") {
              setErrorRegionalManager("Please select regional manager");
            } else {
              setErrorRegionalManager("");
            }
            if (uniqueAPIs?.length > 0 || CheckDashboardPermissions) {
              setpermissionsError("");
            } else {
              setpermissionsError("Please select permissions");
            }
          }
        } else if (
          ApplicationState.UserType === "regional_sales_team" &&
          ApplicationState.RegionType === "regional_manager"
        ) {
          if (
            ApplicationState?.FullName.trim() !== "" &&
            ApplicationState?.Mobile.trim() !== "" &&
            ApplicationState?.UserType !== "" &&
            ApplicationState?.RelatedID !== "" &&
            ApplicationState?.Email.trim() !== "" &&
            ApplicationState?.Address.length <= 300 &&
            ApplicationState?.address2?.length <= 300 &&
            ApplicationState?.RegionType !== "" &&
            (uniqueAPIs?.length > 0 || CheckDashboardPermissions)
          ) {
            if (
              EmailRegex.test(ApplicationState?.Email) === true &&
              CheckMobileNumber?.valid === true
            ) {
              Dispatch(
                StartMainCommonLoader({
                  url: "user_add",
                  loader: true,
                })
              );
              let param = {
                transmit: "broadcast",
                url: "user_add",
                request: {
                  full_name: ApplicationState?.FullName,
                  email: ApplicationState?.Email,
                  mobile: ApplicationState?.Mobile,
                  address: ApplicationState?.Address,
                  address2: ApplicationState?.address2,
                  user_type:
                    ApplicationState?.RegionType === "regional_manager"
                      ? ApplicationState?.UserType + "_rm"
                      : ApplicationState?.UserType + "_asm",
                  permissions: uniqueAPIs,
                  permissions_access: modules,
                  related_id:
                    ApplicationState?.RegionType === "regional_manager"
                      ? ApplicationState?.RelatedID?.value
                      : ApplicationState?.Regional_manager?.value,
                  is_active: ApplicationState?.Status,
                },
                DeviceId: device_id,
              };
              wsSend_request(websocket, param);
            } else {
              CheckValid(ApplicationState?.Mobile, {
                type: "phone",
                error: seterrorMobile,
              });
              CheckValid(ApplicationState?.Email.trim(), {
                type: "email",
                error: seterrorEmail,
              });
            }
          } else {
            if (ApplicationState?.Address.length > 300) {
              CheckValid(ApplicationState?.Address.trim(), {
                type: "Address",
                error: seterrorAddress,
              });
            }
            if (ApplicationState?.address2?.length > 300) {
              CheckValid(ApplicationState?.address2?.trim(), {
                type: "address2",
                error: seterrorAddress2,
              });
            }
            CheckValid(ApplicationState?.Mobile, {
              type: "phone",
              error: seterrorMobile,
            });
            CheckValid(ApplicationState?.FullName.trim(), {
              type: "FullName",
              error: seterrorFirstName,
            });
            CheckValid(ApplicationState?.Email.trim(), {
              type: "email",
              error: seterrorEmail,
            });
            if (ApplicationState?.RegionType === "") {
              seterrorerrorRegionalType("Please select type");
            } else {
              seterrorerrorRegionalType("");
            }
            if (ApplicationState?.Regional_manager === "") {
              setErrorRegionalManager("Please select regional manager");
            } else {
              setErrorRegionalManager("");
            }
            if (ApplicationState?.UserType === "") {
              seterrorUserType("Please select user team");
            } else {
              seterrorUserType("");
            }
            if (ApplicationState?.RelatedID === "") {
              if (
                ApplicationState.UserType === "regional_sales_team" &&
                ApplicationState.RegionType === "regional_manager"
              ) {
                seterrorRelatedID(`Please select region`);
              } else {
                if (ApplicationState?.UserType === "sale_franchise_person") {
                  seterrorRelatedID(`Please select franchise master`);
                } else {
                  seterrorRelatedID(
                    `Please select ${ApplicationState?.UserType?.replaceAll(
                      "_",
                      " "
                    )}`
                  );
                }
              }
            } else {
              seterrorRelatedID("");
            }
            if (uniqueAPIs?.length > 0 || CheckDashboardPermissions) {
              setpermissionsError("");
            } else {
              setpermissionsError("Please select permissions");
            }
          }
        } else if (ApplicationState.UserType === "sale_franchise_person") {
          if (
            ApplicationState?.FullName.trim() !== "" &&
            ApplicationState?.Mobile.trim() !== "" &&
            ApplicationState?.UserType !== "" &&
            ApplicationState?.RelatedID !== "" &&
            ApplicationState?.Email.trim() !== "" &&
            KYCState.AccountNumber !== "" &&
            KYCState.IFSCCode !== "" &&
            BankVerifiedStatus === "Verified" &&
            KYCState?.AadhaarNumber !== "" &&
            ApplicationState?.Address.length <= 300 &&
            ApplicationState?.address2?.length <= 300 &&
            (uniqueAPIs?.length > 0 || CheckDashboardPermissions)
          ) {
            if (
              EmailRegex.test(ApplicationState?.Email) === true &&
              CheckMobileNumber?.valid === true
            ) {
              Dispatch(
                StartMainCommonLoader({
                  url: "user_add",
                  loader: true,
                })
              );
              let param = {
                transmit: "broadcast",
                url: "user_add",
                request: {
                  full_name: ApplicationState?.FullName,
                  email: ApplicationState?.Email,
                  mobile: ApplicationState?.Mobile,
                  address: ApplicationState?.Address,
                  address2: ApplicationState?.address2,
                  user_type: ApplicationState?.UserType,
                  permissions: uniqueAPIs,
                  permissions_access: modules,
                  related_id: ApplicationState?.RelatedID?.value,
                  is_bank_verified:
                    BankVerifiedStatus === "Verified" ? true : false,
                  account_holder_name: KYCState?.AccountHolderName,
                  bank_name: KYCState?.AccountBankName,
                  account_number: KYCState?.AccountNumber,
                  ifsc_code: KYCState?.IFSCCode,
                  is_adhar_verified:
                    AadharVerifiedStatus === "Verified" ? true : false,
                  adhar_id: KYCState?.AadhaarNumber,
                  is_active: ApplicationState?.Status,
                },
                DeviceId: device_id,
              };
              wsSend_request(websocket, param);
            } else {
              CheckValid(ApplicationState?.Mobile, {
                type: "phone",
                error: seterrorMobile,
              });
              CheckValid(ApplicationState?.Email.trim(), {
                type: "email",
                error: seterrorEmail,
              });
            }
          } else {
            if (ApplicationState?.Address.length > 300) {
              CheckValid(ApplicationState?.Address.trim(), {
                type: "Address",
                error: seterrorAddress,
              });
            }
            if (ApplicationState?.address2?.length > 300) {
              CheckValid(ApplicationState?.address2?.trim(), {
                type: "address2",
                error: seterrorAddress2,
              });
            }
            CheckValid(ApplicationState?.Mobile, {
              type: "phone",
              error: seterrorMobile,
            });
            CheckValid(ApplicationState?.FullName.trim(), {
              type: "FullName",
              error: seterrorFirstName,
            });
            CheckValid(ApplicationState?.Email.trim(), {
              type: "email",
              error: seterrorEmail,
            });
            if (ApplicationState?.UserType === "") {
              seterrorUserType("Please select user team");
            } else {
              seterrorUserType("");
            }
            if (ApplicationState?.RelatedID === "") {
              if (
                ApplicationState.UserType === "regional_sales_team" &&
                ApplicationState.RegionType === "regional_manager"
              ) {
                seterrorRelatedID(`Please select region`);
              } else {
                if (ApplicationState?.UserType === "sale_franchise_person") {
                  seterrorRelatedID(`Please select franchise master`);
                } else {
                  seterrorRelatedID(
                    `Please select ${ApplicationState?.UserType?.replaceAll(
                      "_",
                      " "
                    )}`
                  );
                }
              }
            } else {
              seterrorRelatedID("");
            }
            if (uniqueAPIs?.length > 0 || CheckDashboardPermissions) {
              setpermissionsError("");
            } else {
              setpermissionsError("Please select permissions");
            }
            CheckValid(KYCState?.AccountNumber, {
              type: "AccountNumber",
              error: setErrorAccountNumber,
            });
            CheckValid(KYCState.IFSCCode, {
              type: "IFSCCode",
              error: setErrorIFSCcodeNumber,
            });
            CheckValid(KYCState?.AadhaarNumber, {
              type: "AadhaarNumber",
              error: setErrorAadhaarNumber,
            });
            if (
              BankVerifiedStatus === "Unverified" ||
              BankVerifiedStatus === ""
            ) {
              setBankVerifiedStatus("Unverified");
            }
          }
        } else if (
          ApplicationState.UserType === "sales_operations" ||
          ApplicationState?.UserType === "inventory_operations" ||
          ApplicationState?.UserType === "logistics_ops" ||
          ApplicationState?.UserType === "accounts" ||
          ApplicationState?.UserType === "inside_sales" ||
          ApplicationState?.UserType === "ecommerce"
        ) {
          if (
            ApplicationState?.FullName.trim() !== "" &&
            ApplicationState?.Mobile.trim() !== "" &&
            ApplicationState?.UserType !== "" &&
            ApplicationState?.Email.trim() !== "" &&
            ApplicationState?.Address.length <= 300 &&
            ApplicationState?.address2?.length <= 300 &&
            (uniqueAPIs?.length > 0 || CheckDashboardPermissions)
          ) {
            if (
              EmailRegex.test(ApplicationState?.Email) === true &&
              CheckMobileNumber?.valid === true
            ) {
              Dispatch(
                StartMainCommonLoader({
                  url: "user_add",
                  loader: true,
                })
              );
              let param = {
                transmit: "broadcast",
                url: "user_add",
                request: {
                  full_name: ApplicationState?.FullName,
                  email: ApplicationState?.Email,
                  mobile: ApplicationState?.Mobile,
                  address: ApplicationState?.Address,
                  address2: ApplicationState?.address2,
                  user_type: ApplicationState?.UserType,
                  permissions: uniqueAPIs,
                  permissions_access: modules,
                  is_active: ApplicationState?.Status,
                },
                DeviceId: device_id,
              };
              wsSend_request(websocket, param);
            } else {
              CheckValid(ApplicationState?.Mobile, {
                type: "phone",
                error: seterrorMobile,
              });
              CheckValid(ApplicationState?.Email.trim(), {
                type: "email",
                error: seterrorEmail,
              });
            }
          } else {
            if (ApplicationState?.Address.length > 300) {
              CheckValid(ApplicationState?.Address.trim(), {
                type: "Address",
                error: seterrorAddress,
              });
            }
            if (ApplicationState?.address2?.length > 300) {
              CheckValid(ApplicationState?.address2?.trim(), {
                type: "address2",
                error: seterrorAddress2,
              });
            }
            CheckValid(ApplicationState?.Mobile, {
              type: "phone",
              error: seterrorMobile,
            });
            CheckValid(ApplicationState?.FullName.trim(), {
              type: "FullName",
              error: seterrorFirstName,
            });
            CheckValid(ApplicationState?.Email.trim(), {
              type: "email",
              error: seterrorEmail,
            });
            if (ApplicationState?.UserType === "") {
              seterrorUserType("Please select user team");
            } else {
              seterrorUserType("");
            }
            if (ApplicationState?.RelatedID === "") {
              if (
                ApplicationState.UserType === "regional_sales_team" &&
                ApplicationState.RegionType === "regional_manager"
              ) {
                seterrorRelatedID(`Please select region`);
              } else {
                if (ApplicationState?.UserType === "sale_franchise_person") {
                  seterrorRelatedID(`Please select franchise master`);
                } else {
                  seterrorRelatedID(
                    `Please select ${ApplicationState?.UserType?.replaceAll(
                      "_",
                      " "
                    )}`
                  );
                }
              }
            } else {
              seterrorRelatedID("");
            }
            if (uniqueAPIs?.length > 0 || CheckDashboardPermissions) {
              setpermissionsError("");
            } else {
              setpermissionsError("Please select permissions");
            }
          }
        } else if (ApplicationState.UserType === "after_sales_and_service") {
          if (
            ApplicationState?.FullName.trim() !== "" &&
            ApplicationState?.Mobile.trim() !== "" &&
            ApplicationState?.UserType !== "" &&
            ApplicationState?.Email.trim() !== "" &&
            ApplicationState?.Address.length <= 300 &&
            ApplicationState?.address2?.length <= 300 &&
            (uniqueAPIs?.length > 0 || CheckDashboardPermissions)
          ) {
            if (
              EmailRegex.test(ApplicationState?.Email) === true &&
              CheckMobileNumber?.valid === true
            ) {
              Dispatch(
                StartMainCommonLoader({
                  url: "user_add",
                  loader: true,
                })
              );
              let param = {
                transmit: "broadcast",
                url: "user_add",
                request: {
                  full_name: ApplicationState?.FullName,
                  email: ApplicationState?.Email,
                  mobile: ApplicationState?.Mobile,
                  address: ApplicationState?.Address,
                  address2: ApplicationState?.address2,
                  user_type: ApplicationState?.UserType,
                  permissions: uniqueAPIs,
                  permissions_access: modules,
                  is_active: ApplicationState?.Status,
                },
                DeviceId: device_id,
              };
              wsSend_request(websocket, param);
            } else {
              CheckValid(ApplicationState?.Mobile, {
                type: "phone",
                error: seterrorMobile,
              });
              CheckValid(ApplicationState?.Email.trim(), {
                type: "email",
                error: seterrorEmail,
              });
            }
          } else {
            CheckValid(ApplicationState?.Mobile, {
              type: "phone",
              error: seterrorMobile,
            });
            CheckValid(ApplicationState?.FullName.trim(), {
              type: "FullName",
              error: seterrorFirstName,
            });
            CheckValid(ApplicationState?.Email.trim(), {
              type: "email",
              error: seterrorEmail,
            });

            if (ApplicationState?.Address.length > 300) {
              CheckValid(ApplicationState?.Address.trim(), {
                type: "Address",
                error: seterrorAddress,
              });
            }
            if (ApplicationState?.address2?.length > 300) {
              CheckValid(ApplicationState?.address2?.trim(), {
                type: "address2",
                error: seterrorAddress2,
              });
            }
            if (ApplicationState?.UserType === "") {
              seterrorUserType("Please select user team");
            } else {
              seterrorUserType("");
            }
            if (uniqueAPIs?.length > 0 || CheckDashboardPermissions) {
              setpermissionsError("");
            } else {
              setpermissionsError("Please select permissions");
            }
          }
        } else {
          if (
            ApplicationState?.FullName.trim() !== "" &&
            ApplicationState?.Mobile.trim() !== "" &&
            ApplicationState?.UserType !== "" &&
            ApplicationState?.RelatedID !== "" &&
            ApplicationState?.Email.trim() !== "" &&
            ApplicationState?.Address.length <= 300 &&
            ApplicationState?.address2?.length <= 300 &&
            (uniqueAPIs?.length > 0 || CheckDashboardPermissions)
          ) {
            if (
              EmailRegex.test(ApplicationState?.Email) === true &&
              CheckMobileNumber?.valid === true
            ) {
              Dispatch(
                StartMainCommonLoader({
                  url: "user_add",
                  loader: true,
                })
              );
              let param = {
                transmit: "broadcast",
                url: "user_add",
                request: {
                  full_name: ApplicationState?.FullName,
                  email: ApplicationState?.Email,
                  mobile: ApplicationState?.Mobile,
                  address: ApplicationState?.Address,
                  address2: ApplicationState?.address2,
                  user_type: ApplicationState?.UserType,
                  permissions: uniqueAPIs,
                  permissions_access: modules,
                  related_id: ApplicationState?.RelatedID?.value,
                  is_active: ApplicationState?.Status,
                },
                DeviceId: device_id,
              };
              wsSend_request(websocket, param);
            } else {
              CheckValid(ApplicationState?.Mobile, {
                type: "phone",
                error: seterrorMobile,
              });
              CheckValid(ApplicationState?.Email.trim(), {
                type: "email",
                error: seterrorEmail,
              });
            }
          } else {
            if (ApplicationState?.Address.length > 300) {
              CheckValid(ApplicationState?.Address.trim(), {
                type: "Address",
                error: seterrorAddress,
              });
            }
            if (ApplicationState?.address2?.length > 300) {
              CheckValid(ApplicationState?.address2?.trim(), {
                type: "address2",
                error: seterrorAddress2,
              });
            }
            CheckValid(ApplicationState?.Mobile, {
              type: "phone",
              error: seterrorMobile,
            });
            CheckValid(ApplicationState?.FullName.trim(), {
              type: "FullName",
              error: seterrorFirstName,
            });
            CheckValid(ApplicationState?.Email.trim(), {
              type: "email",
              error: seterrorEmail,
            });
            if (ApplicationState?.RegionType === "") {
              seterrorerrorRegionalType("Please select type");
            } else {
              seterrorerrorRegionalType("");
            }
            if (ApplicationState?.Regional_manager === "") {
              setErrorRegionalManager("Please select regional manager");
            } else {
              setErrorRegionalManager("");
            }
            if (ApplicationState?.UserType === "") {
              seterrorUserType("Please select user team");
            } else {
              seterrorUserType("");
            }
            if (ApplicationState?.RelatedID === "") {
              if (ApplicationState?.UserType === "sale_franchise_person") {
                seterrorRelatedID(`Please select franchise master`);
              } else {
                seterrorRelatedID(
                  `Please select ${ApplicationState?.UserType?.replaceAll(
                    "_",
                    " "
                  )}`
                );
              }
            } else {
              seterrorRelatedID("");
            }
            if (uniqueAPIs?.length > 0 || CheckDashboardPermissions) {
              setpermissionsError("");
            } else {
              setpermissionsError("Please select permissions");
            }
          }
        }
      } else {
        if (
          ApplicationState?.FullName.trim() !== "" &&
          ApplicationState?.Mobile.trim() !== "" &&
          ApplicationState?.UserType !== "" &&
          ApplicationState?.Email.trim() !== "" &&
          ApplicationState?.Address.length <= 300 &&
          ApplicationState?.address2?.length <= 300 &&
          (uniqueAPIs?.length > 0 || CheckDashboardPermissions)
        ) {
          if (
            EmailRegex.test(ApplicationState?.Email) === true &&
            CheckMobileNumber?.valid === true
          ) {
            Dispatch(
              StartMainCommonLoader({
                url: "user_add",
                loader: true,
              })
            );
            let param = {
              transmit: "broadcast",
              url: "user_add",
              request: {
                full_name: ApplicationState?.FullName,
                email: ApplicationState?.Email,
                mobile: ApplicationState?.Mobile,
                address: ApplicationState?.Address,
                address2: ApplicationState?.address2,
                user_type: ApplicationState?.UserType,
                permissions: uniqueAPIs,
                permissions_access: modules,
                is_active: ApplicationState?.Status,
              },
              DeviceId: device_id,
            };
            wsSend_request(websocket, param);
          } else {
            CheckValid(ApplicationState?.Mobile, {
              type: "phone",
              error: seterrorMobile,
            });
            CheckValid(ApplicationState?.Email.trim(), {
              type: "email",
              error: seterrorEmail,
            });
          }
        } else {
          if (ApplicationState?.Address.length > 300) {
            CheckValid(ApplicationState?.Address.trim(), {
              type: "Address",
              error: seterrorAddress,
            });
          }
          if (ApplicationState?.address2?.length > 300) {
            CheckValid(ApplicationState?.address2?.trim(), {
              type: "address2",
              error: seterrorAddress2,
            });
          }
          CheckValid(ApplicationState?.Mobile, {
            type: "phone",
            error: seterrorMobile,
          });
          CheckValid(ApplicationState?.FullName.trim(), {
            type: "FullName",
            error: seterrorFirstName,
          });
          CheckValid(ApplicationState?.Email.trim(), {
            type: "email",
            error: seterrorEmail,
          });
          seterrorerrorRegionalType("Please select type");
          if (ApplicationState?.UserType === "") {
            seterrorUserType("Please select user team");
          } else {
            seterrorUserType("");
          }
          if (uniqueAPIs?.length > 0 || CheckDashboardPermissions) {
            setpermissionsError("");
          } else {
            setpermissionsError("Please select permissions");
          }
        }
      }
    }
  };

  useEffect(() => {
    if (ClearFormSet?.action === 200) {
      Navigate(USER_MANAGEMENT_URL);
    }
  }, [ClearFormSet]);

  document.addEventListener("wheel", function (event) {
    if (
      document.activeElement.type === "number" &&
      document.activeElement.classList.contains("inputBoxs")
    ) {
      document.activeElement.blur();
    }
  });

  // Bank and Aadhaar details reset function
  const reset_form = (url) => {
    if (url === "bank_details") {
      setKYCState({
        ...KYCState,
        AccountNumber: "",
        IFSCCode: "",
      });
      setBankVerifiedStatus("");
    } else {
      setKYCState({
        ...KYCState,
        AadhaarNumber: "",
      });
      setAadharVerifiedStatus("");
    }
  };

  // verify succes and fail modal
  const verifyDetailsSuccess = async (url) => {
    const payload = {};
    if (url === "bank_account_details") {
      payload.id_number = KYCState.AccountNumber;
      payload.ifsc = KYCState.IFSCCode;
      payload.ifsc_details = true;

      setcommonVerifyLoader({
        ...commonVerifyLoader,
        bank_details_loader: true,
      });
    } else {
      payload.id_number = KYCState.AadhaarNumber;

      setcommonVerifyLoader({
        ...commonVerifyLoader,
        adhar_loader: true,
      });
    }
    const bankDetailsResponse = await BankDetailVerify(
      url === "bank_account_details"
        ? REACT_APP_BANK_ACCOUNT_VERIFY_URL
        : REACT_APP_ADHAAR_CARD_VERIFY_URL,
      payload,
      url
    );

    if (bankDetailsResponse?.status === 200) {
      if (url === "aadhaar_card_details") {
        setcommonVerifyLoader({
          ...commonVerifyLoader,
          adhar_loader: false,
        });
        setVerifyModalState({
          ...VerifyModalState,
          open: true,
          title: "Enter the OTP to verify your Aadhaar card.",
          modalType: url,
          data: bankDetailsResponse?.data,
        });
        toast.info(
          "OTP for Aadhaar verification has been successfully generated and sent to your registered mobile number."
        );
      } else {
        setcommonVerifyLoader({
          ...commonVerifyLoader,
          bank_details_loader: false,
        });
        setKYCState({
          ...KYCState,
          AccountHolderName: bankDetailsResponse?.data?.full_name,
          AccountBankName: bankDetailsResponse?.data?.ifsc_details?.bank_name,
        });

        setVerifyModalState({
          ...VerifyModalState,
          open: true,
          title: "Your bank details verified successfully.",
          modalType: url,
          data: bankDetailsResponse?.data,
        });
        setBankVerifiedStatus("Verified");
        toast.info("Bank details verified successfully.");
      }
    } else {
      if (url === "bank_account_details") {
        setcommonVerifyLoader({
          ...commonVerifyLoader,
          bank_details_loader: false,
        });
        setBankVerifiedStatus("Unverified");
      } else {
        setcommonVerifyLoader({
          ...commonVerifyLoader,
          adhar_loader: false,
        });
        setAadharVerifiedStatus("Unverified");
      }
      if (bankDetailsResponse?.data?.message) {
        toast.error(bankDetailsResponse?.data?.message);
      } else {
        toast.error(bankDetailsResponse?.message);
      }
    }
  };

  return (
    <section className="createApplcation_wrapper">
      <div className="MainHeader">
        <Link to={USER_MANAGEMENT_URL} className="btn btn-link backbtn">
          <i className="bi bi-arrow-left-short"></i> Back
        </Link>
      </div>
      <div className="tabsWrappersmAN">
        <CommonScrollBar
          className={"ScrollbarsSidebar"}
          height={{ height: "calc(100vh - 134px)" }}
        >
          <div className="formloginset">
            <div className="row">
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Full Name<span className="mendatory_star">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={ApplicationState?.FullName}
                    onChange={(e) =>
                      setApplicationState({
                        ...ApplicationState,
                        FullName: e.target.value,
                      })
                    }
                    onKeyUp={(e) =>
                      CheckValid(e.target.value, {
                        type: "FullName",
                        error: seterrorFirstName,
                      })
                    }
                    onKeyDown={EmptySpaceFieldValid}
                    placeholder="Enter Full Name"
                    disabled={
                      CurrentData_?.user_type === "franchise_manager"
                        ? true
                        : UploadFileLoader
                    }
                  />
                  {errorFirstName !== "" && (
                    <span className="error_medotory">{errorFirstName}</span>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Email Address<span className="mendatory_star">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={ApplicationState?.Email}
                    onChange={(e) =>
                      setApplicationState({
                        ...ApplicationState,
                        Email: e.target.value,
                      })
                    }
                    onKeyUp={(e) =>
                      CheckValid(e.target.value, {
                        type: "email",
                        error: seterrorEmail,
                      })
                    }
                    onKeyDown={EmptySpaceFieldValid}
                    placeholder="Enter Email Address"
                    disabled={
                      CurrentData_?.user_type === "franchise_manager"
                        ? true
                        : UploadFileLoader
                    }
                  />
                  {errorEmail !== "" && (
                    <span className="error_medotory">{errorEmail}</span>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Mobile Number<span className="mendatory_star">*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    className="inputBoxs"
                    value={ApplicationState?.Mobile}
                    onChange={(e) =>
                      setApplicationState({
                        ...ApplicationState,
                        Mobile: e.target.value.replace(/^0/, ""),
                      })
                    }
                    onKeyUp={(e) =>
                      CheckValid(e.target.value, {
                        type: "phone",
                        error: seterrorMobile,
                      })
                    }
                    onKeyDown={(e) => {
                      EmptySpaceFieldValid(e);
                      exceptThisCostSymbols.includes(e.key) &&
                        e.preventDefault();
                    }}
                    placeholder="Enter Mobile Number"
                    disabled={
                      CurrentData_?.user_type === "franchise_manager"
                        ? true
                        : UploadFileLoader
                    }
                  />
                  {errorMobile !== "" && (
                    <span className="error_medotory">{errorMobile}</span>
                  )}
                </Form.Group>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Team<span className="mendatory_star">*</span>
                  </Form.Label>
                  {CurrentData_?.user_type === "franchise_manager" ? (
                    <b style={{ fontSize: "14px", fontWeight: "500" }}>
                      Franchise Manager
                    </b>
                  ) : (
                    <React.Fragment>
                      <select
                        className="form-control"
                        value={ApplicationState.UserType}
                        onChange={(e) => SelectUserType(e.target.value)}
                      >
                        <option value={""}>Select Team</option>
                        <option value={"admin"}>Admin</option>
                        <option value={"sales_operations"}>
                          Sales Operations
                        </option>
                        <option value={"warehouse_manager"}>
                          Warehouse Manager
                        </option>
                        <option value={"inventory_operations"}>
                          Inventory Operations
                        </option>
                        <option value={"logistics_ops"}>Logistics Ops</option>
                        <option value={"accounts"}>Accounts</option>
                        <option value={"regional_sales_team"}>
                          Regional Sales Team
                        </option>
                        <option value={"inside_sales"}>Inside Sales</option>
                        <option value={"ecommerce"}>Ecommerce</option>
                        <option value={"sale_franchise_person"}>
                          Sale Franchise Person
                        </option>
                        <option value={"after_sales_and_service"}>
                          After Sales and Service
                        </option>
                      </select>
                      {errorUserType !== "" && (
                        <span className="error_medotory">{errorUserType}</span>
                      )}
                    </React.Fragment>
                  )}
                </Form.Group>
              </div>
              {ApplicationState.UserType === "regional_sales_team" && (
                <div className="col-md-4">
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Type<span className="mendatory_star">*</span>
                    </Form.Label>
                    <select
                      className="form-control"
                      value={ApplicationState.RegionType}
                      onChange={(e) => SelectRegionalType(e.target.value)}
                    >
                      <option value={""}>Select Regional Type</option>
                      <option value={"regional_manager"}>RM</option>
                      <option value={"assistant_sales_manager"}>ASM</option>
                    </select>
                    {errorRegionalType !== "" && (
                      <span className="error_medotory">
                        {errorRegionalType}
                      </span>
                    )}
                  </Form.Group>
                </div>
              )}
              {ApplicationState.UserType === "regional_sales_team" &&
                (ApplicationState.RegionType === "regional_manager" ||
                  ApplicationState.RegionType ===
                    "assistant_sales_manager") && (
                  <div className="col-md-4">
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Region Master<span className="mendatory_star">*</span>
                      </Form.Label>
                      <div
                        className="selectMultiselect selectMultiselectBrand"
                        id="selectMultiselectBrand"
                      >
                        <Select
                          value={ApplicationState?.RelatedID}
                          onChange={(e) =>
                            SelectRelatedType(e, "regional manager")
                          }
                          // defaultValue={defaultRegionOption}
                          isClearable
                          options={optionsRegion}
                          className="godown-select-container"
                          classNamePrefix="godown-select"
                          styles={customStyles}
                          menuPlacement="auto"
                          menuPortalTarget={document.body}
                          filterOption={customFilterOption}
                        />
                      </div>
                      {errorRelatedID !== "" && (
                        <span className="error_medotory">{errorRelatedID}</span>
                      )}
                    </Form.Group>
                  </div>
                )}
              {ApplicationState.RegionType === "assistant_sales_manager" &&
                ApplicationState?.RelatedID !== "" && (
                  <div className="col-md-4">
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Region Manager<span className="mendatory_star">*</span>
                      </Form.Label>
                      <div
                        className="selectMultiselect selectMultiselectBrand"
                        id="selectMultiselectBrand"
                      >
                        <Select
                          value={ApplicationState?.Regional_manager}
                          onChange={(e) => SelectRegionalManager(e)}
                          isClearable
                          options={optionsRegionalManager}
                          className="godown-select-container"
                          classNamePrefix="godown-select"
                          styles={customStyles}
                          menuPlacement="auto"
                          menuPortalTarget={document.body}
                          filterOption={customFilterOption}
                        />
                      </div>
                      {errorRegionalManager !== "" && (
                        <span className="error_medotory">
                          {errorRegionalManager}
                        </span>
                      )}
                    </Form.Group>
                  </div>
                )}
              {ApplicationState.UserType === "warehouse_manager" && (
                <div className="col-md-4">
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Warehouse Master<span className="mendatory_star">*</span>
                    </Form.Label>
                    <div
                      className="selectMultiselect selectMultiselectBrand"
                      id="selectMultiselectBrand"
                    >
                      <Select
                        value={ApplicationState?.RelatedID}
                        onChange={(e) =>
                          SelectRelatedType(e, "warehouse manager")
                        }
                        // defaultValue={defaultWareHouseOption}
                        isClearable
                        options={optionsWareHouse}
                        className="godown-select-container"
                        classNamePrefix="godown-select"
                        styles={customStyles}
                        menuPlacement="auto"
                        menuPortalTarget={document.body}
                        filterOption={customFilterOption}
                      />
                    </div>
                    {errorRelatedID !== "" && (
                      <span className="error_medotory">{errorRelatedID}</span>
                    )}
                  </Form.Group>
                </div>
              )}
              {ApplicationState.UserType === "sale_franchise_person" && (
                <React.Fragment>
                  <div className="col-md-4">
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Franchise Master
                        <span className="mendatory_star">*</span>
                      </Form.Label>
                      <div
                        className="selectMultiselect selectMultiselectBrand"
                        id="selectMultiselectBrand"
                      >
                        <Select
                          value={ApplicationState?.RelatedID}
                          onChange={(e) =>
                            SelectRelatedType(e, "franchise master")
                          }
                          // defaultValue={defaultFranchiseOption}
                          isClearable
                          options={optionsFranchise}
                          className="godown-select-container"
                          classNamePrefix="godown-select"
                          styles={customStyles}
                          menuPlacement="auto"
                          menuPortalTarget={document.body}
                          filterOption={customFilterOption}
                        />
                      </div>
                      {errorRelatedID !== "" && (
                        <span className="error_medotory">{errorRelatedID}</span>
                      )}
                    </Form.Group>
                  </div>
                  <div className="col-md-12">
                    <div className="HeaderDivider">
                      <h6 className="subtitleForm">
                        <i className="bi bi-bank"></i> Bank Account Details
                        {BankVerifiedStatus !== "" && (
                          <>
                            {BankVerifiedStatus === "Verified" ? (
                              <div className="verifySpan">
                                <i className="bi bi-check-circle-fill"></i>{" "}
                                Verified
                              </div>
                            ) : (
                              <div className="verifySpan verifySpanerror">
                                <i className="bi bi-x-circle-fill"></i>{" "}
                                Unverified
                              </div>
                            )}
                          </>
                        )}
                      </h6>
                      <div className="row">
                        <div className="col-md-4">
                          <Form.Group className="mb-3">
                            <Form.Label>
                              Account Number
                              <span className="mendatory_star">*</span>
                            </Form.Label>
                            <Form.Control
                              type="number"
                              className="inputBoxs"
                              value={KYCState?.AccountNumber}
                              onChange={(e) =>
                                setKYCState({
                                  ...KYCState,
                                  AccountNumber: e.target.value,
                                })
                              }
                              onKeyDown={(e) => {
                                EmptySpaceFieldValid(e);
                                exceptThisCostSymbols.includes(e.key) &&
                                  e.preventDefault();
                              }}
                              onKeyUp={(e) =>
                                CheckValid(e.target.value, {
                                  type: "AccountNumber",
                                  error: setErrorAccountNumber,
                                })
                              }
                              disabled={
                                UploadFileLoader ||
                                commonVerifyLoader?.bank_details_loader ||
                                BankVerifiedStatus === "Verified"
                              }
                              placeholder="Enter Account Number"
                            />
                            {errorAccountNumber !== "" && (
                              <span className="error_medotory">
                                {errorAccountNumber}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                        <div className="col-md-4">
                          <Form.Group className="mb-3">
                            <Form.Label>
                              IFSC Code<span className="mendatory_star">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              value={KYCState?.IFSCCode}
                              onChange={(e) =>
                                setKYCState({
                                  ...KYCState,
                                  IFSCCode: e.target.value,
                                })
                              }
                              onKeyUp={(e) =>
                                CheckValid(e.target.value, {
                                  type: "IFSCCode",
                                  error: setErrorIFSCcodeNumber,
                                })
                              }
                              onKeyDown={EmptySpaceFieldValid}
                              disabled={
                                UploadFileLoader ||
                                commonVerifyLoader?.bank_details_loader ||
                                BankVerifiedStatus === "Verified"
                              }
                              placeholder="Enter IFSC Code"
                            />
                            {errorIFSCcodeNumber !== "" && (
                              <span className="error_medotory">
                                {errorIFSCcodeNumber}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                        <div className="col-md-4">
                          <Form.Group className="mb-3">
                            <Form.Label>&nbsp;</Form.Label>
                            <div style={{ float: "left", width: "auto" }}>
                              <Button
                                className="verify_btn"
                                disabled={
                                  !KYCState?.AccountNumber ||
                                  !KYCState?.IFSCCode ||
                                  BankVerifiedStatus === "Verified" ||
                                  commonVerifyLoader?.bank_details_loader
                                }
                                onClick={() =>
                                  verifyDetailsSuccess("bank_account_details")
                                }
                              >
                                <i className="bi bi-check2-circle"></i> Verify
                              </Button>
                              <Button
                                className="reset_btn"
                                id="reset_btn"
                                onClick={() => reset_form("bank_details")}
                                disabled={
                                  !KYCState?.AccountNumber &&
                                  !KYCState?.IFSCCode
                                }
                              >
                                <i className="bi bi-x-circle"></i> Reset
                              </Button>
                              {commonVerifyLoader?.bank_details_loader && (
                                <div className="loader_wrapper">
                                  <Spinner />
                                </div>
                              )}
                            </div>
                          </Form.Group>
                        </div>
                      </div>

                      {BankVerifiedStatus === "Unverified" && (
                        <Alert variant="danger" className="bank_details_alerts">
                          <i className="bi bi-x-circle-fill"></i> Bank account
                          details must be verified first.
                        </Alert>
                      )}
                    </div>
                    <div className="HeaderDivider">
                      <h6 className="subtitleForm">
                        <i className="bi bi-postcard"></i> Aadhaar Card Details
                        {AadharVerifiedStatus !== "" && (
                          <>
                            {AadharVerifiedStatus === "Verified" ? (
                              <div className="verifySpan">
                                <i className="bi bi-check-circle-fill"></i>{" "}
                                Verified
                              </div>
                            ) : (
                              <div className="verifySpan verifySpanerror">
                                <i className="bi bi-x-circle-fill"></i>{" "}
                                Unverified
                              </div>
                            )}
                          </>
                        )}
                      </h6>
                      <div className="row">
                        <div className="col-md-4">
                          <Form.Group className="mb-3">
                            <Form.Label>
                              Aadhaar Number
                              <span className="mendatory_star">*</span>
                            </Form.Label>
                            <Form.Control
                              type="number"
                              className="inputBoxs"
                              value={KYCState?.AadhaarNumber}
                              onChange={(e) =>
                                setKYCState({
                                  ...KYCState,
                                  AadhaarNumber: e.target.value.replace(
                                    /^0/,
                                    ""
                                  ),
                                })
                              }
                              onKeyUp={(e) =>
                                CheckValid(e.target.value, {
                                  type: "AadhaarNumber",
                                  error: setErrorAadhaarNumber,
                                })
                              }
                              onKeyDown={(e) => {
                                EmptySpaceFieldValid(e);
                                exceptThisCostSymbols.includes(e.key) &&
                                  e.preventDefault();
                              }}
                              disabled={
                                UploadFileLoader ||
                                commonVerifyLoader?.adhar_loader ||
                                AadharVerifiedStatus === "Verified"
                              }
                              placeholder="Enter Number"
                              maxLength={12}
                            />
                            {errorAadhaarNumber !== "" && (
                              <span className="error_medotory">
                                {errorAadhaarNumber}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                        <div className="col-md-4">
                          <Form.Group className="mb-3">
                            <Form.Label>&nbsp;</Form.Label>
                            <div style={{ float: "left", width: "auto" }}>
                              <Button
                                className="verify_btn"
                                disabled={
                                  AadharVerifiedStatus === "Verified" ||
                                  KYCState?.AadhaarNumber?.length !== 12 ||
                                  commonVerifyLoader?.adhar_loader
                                }
                                onClick={() =>
                                  verifyDetailsSuccess("aadhaar_card_details")
                                }
                              >
                                <i className="bi bi-check2-circle"></i> Verify
                              </Button>
                              <Button
                                className="reset_btn"
                                id="reset_btn"
                                onClick={() => reset_form("aadhaar_details")}
                                disabled={!KYCState?.AadhaarNumber}
                              >
                                <i className="bi bi-x-circle"></i> Reset
                              </Button>
                              {commonVerifyLoader?.adhar_loader && (
                                <div className="loader_wrapper">
                                  <Spinner />
                                </div>
                              )}
                            </div>
                          </Form.Group>
                        </div>
                      </div>
                      {/* {AadharVerifiedStatus === "Unverified" && (<Alert variant="danger" className="bank_details_alerts"><i className="bi bi-x-circle-fill"></i> Aadhaar card details must be verified first.</Alert>)} */}
                    </div>
                  </div>
                </React.Fragment>
              )}
              <div className="col-md-4">
                <CommonAddressTextField
                  Label={"Address Line 1(Optional)"}
                  MainState={ApplicationState}
                  setMainState={setApplicationState}
                  Address={"Address"}
                  isMendatory={false}
                  MaxLength={100}
                />
              </div>
              <div className="col-md-4">
                <CommonAddressTextField
                  Label={"Address Line 2(Optional)"}
                  MainState={ApplicationState}
                  setMainState={setApplicationState}
                  Address={"address2"}
                  isMendatory={false}
                  MaxLength={100}
                />
              </div>
              {CurrentData_?.user_type !== "super_admin" &&
                CurrentData_?.user_type !== "franchise_manager" && (
                  <div className="col-md-4">
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Permissions<span className="mendatory_star">*</span>
                      </Form.Label>
                      <div className="ToggleMainWrap">
                        <Button
                          className="permission-btn"
                          style={{ width: "auto" }}
                          onClick={() =>
                            showPermission(ApplicationState?.UserType)
                          }
                          variant="primary"
                          disabled={ApplicationState?.UserType === ""}
                        >
                          <i className="bi bi-person-check"></i>&nbsp; Add
                          Permission
                        </Button>
                      </div>
                      {permissionsError !== "" && (
                        <span className="error_medotory">
                          {permissionsError}
                        </span>
                      )}
                    </Form.Group>
                  </div>
                )}
              <div className="col-md-2">
                <CommonToggle
                  isBadgeAllow={true}
                  badgeTitle={"active_inactive"}
                  valueToggle={ApplicationState?.Status}
                  setValueToggle={() =>
                    setApplicationState({
                      ...ApplicationState,
                      Status: !ApplicationState?.Status,
                    })
                  }
                  name={"Status"}
                />
              </div>
              {(ApplicationState.UserType === "sale_franchise_person" ||
                ApplicationState.UserType === "franchise_manager") && (
                <div className="col-md-3">
                  <CommonToggle
                    isBadgeAllow={true}
                    badgeTitle={"yes_no"}
                    valueToggle={ApplicationState?.user_verification}
                    setValueToggle={() =>
                      setApplicationState({
                        ...ApplicationState,
                        user_verification: !ApplicationState?.user_verification,
                      })
                    }
                    name={"User Verification"}
                  />
                </div>
              )}
            </div>
            <div className="row">
              <div className="col-md-12" style={{ textAlign: "right" }}>
                <Button
                  className="formbtn widthfullbtn"
                  style={{ width: "auto" }}
                  onClick={() => CreateUser()}
                  variant="primary"
                >
                  {LocationRoute === "edit-user" ? "Update" : "Add"}
                </Button>
              </div>
            </div>
          </div>
        </CommonScrollBar>
      </div>
      {showModalNew?.open && (
        <CommonPermissionModel
          setShowModalNew={setShowModalNew}
          showModalNew={showModalNew}
          modules={modules}
          setModules={setModules}
          ApplicationState={ApplicationState}
        />
      )}
      {(commonMainLoader?.url === "user_add" ||
        commonMainLoader?.url === "user_details") &&
        commonMainLoader?.loader && <CommonLoader />}

      {VerifyModalState?.open && (
        <VerifyModal
          VerifyModalState={VerifyModalState}
          setVerifyModalState={setVerifyModalState}
          setAadharVerifiedStatus={setAadharVerifiedStatus}
          ApplicationState={ApplicationState}
          setApplicationState={setApplicationState}
        />
      )}
    </section>
  );
};

export default AddUser;
